<template >
  <div id="ParentDOM" v-bind:class="[isActive ? 'mainARview' : 'mainARview1']">
    <fullscreen
      id="Zoom1"
      ref="fullscreen"
      :fullscreen.sync="fullscreen"
      @change="fullscreenChange"
      v-bind:style="
        isActive
          ? 'background-image: radial-gradient(#808080, #262626)'
          : 'background-image: radial-gradient(#e6e6e6, #cccccc)'
      "
    >
      <!-- @contextmenu="changeTarget($event)" -->
      <!-- @mousedown.right="panningStart($event)"
        @mouseup.right="panningStop($event)"
        @mousedown.middle="panningStart($event)"
        @mouseup.middle="panningStop($event)"
        @contextmenu.prevent
        @touchstart="panningStartTouch($event)"
        @touchstend="panningStopTouch($event)" -->
      <div
        class="drop-zone"
        v-on:dblclick="addAnnotation()"
        @click="removeTempHotSpot()"
        @contextmenu="changeTarget($event)"
      >
        <!--<svgicon class="drop-zone__prompt" name="Drag and Drop" height="5em"></svgicon>-->

        <div class="drop-zone__prompt">
          <md-icon
            v-if="isActive"
            class="drop-zone__prompt md-size-5x"
            md-src="/static/assets/svg/white/Drag and Drop.svg"
          />
          <md-icon
            v-if="!isActive"
            class="drop-zone__prompt md-size-5x"
            md-src="/static/assets/svg/black/Drag and Drop.svg"
          />
        </div>

        <input type="file" name="ARfile" id="rr" class="drop-zone__input" />
      </div>
      <hide-at breakpoint="mediumAndBelow">
        <div class="ma-0 pa-0">
          <div
            v-if="fullscreen"
            v-bind:class="[
              isActive ? 'file_name_divAR_B' : 'file_name_divAR1_B',
            ]"
          >
            <v-row class="ma-0 pa-0" v-if="isActive">
              <v-col
                cols="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Screenshot.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="toggleFullScreen()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Exit Fullscreen.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <v-col
                col="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="openARwindow()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="!isActive">
              <v-col
                cols="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Screenshot.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="toggleFullScreen" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Exit Fullscreen.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="openARwindow()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <div
            v-if="fullscreen"
            v-bind:class="[isActive ? 'textARview' : 'textARview1']"
          >
            <v-row class="ma-0 pa-0">
              <v-col cols="4"></v-col>
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  text-align: center;
                  font-family: Raleway;
                "
              >
                <div style="display: flex; justify-content: center">
                  <v-img
                    v-if="isActive"
                    @click="changeTheme"
                    class="mt-1"
                    wight="270"
                    height="35"
                    contain
                    v-on:dblclick="removeHDR()"
                    src="/static/assets/svg/augmentablelogowhite.svg"
                    alt="augmentable"
                  />
                  <v-img
                    v-if="!isActive"
                    @click="changeTheme"
                    class="mt-1"
                    wight="270"
                    height="35"
                    contain
                    v-on:dblclick="removeHDR()"
                    src="/static/assets/svg/augmentablelogoblack.svg"
                    alt="augmentable"
                  />
                  <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
                </div>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </div>
        </div>
      </hide-at>

      <show-at breakpoint="mediumAndBelow">
        <div class="ma-0 pa-0">
          <div
            v-if="fullscreen"
            v-bind:class="[isActive ? 'file_name_divAR' : 'file_name_divAR1']"
          >
            <div class="row">
              <div
                class="col-6"
                style="background-color: transparent; text-align: center"
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Screenshot.svg"
                  ></md-icon>
                </v-btn>
              </div>
              <div
                class="col-6"
                style="background-color: transparent; text-align: right"
              >
                <v-btn @click="toggleFullScreen" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Exit Fullscreen.svg"
                  ></md-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div
            v-if="fullscreen"
            v-bind:class="[isActive ? 'textARview' : 'textARview1']"
          >
            <div class="row">
              <div
                class="col-4"
                style="background-color: transparent; text-align: center"
              ></div>
              <div
                class="col-4"
                style="
                  background-color: transparent;
                  text-align: center;
                  font-family: Raleway;
                "
              >
                <v-img
                  v-if="isActive"
                  @click="changeTheme"
                  class="mt-3"
                  wight="220"
                  height="30"
                  contain
                  v-on:dblclick="removeHDR()"
                  src="/static/assets/svg/augmentablelogowhite.svg"
                  alt="augmentable"
                />
                <v-img
                  v-if="!isActive"
                  @click="changeTheme()"
                  class="mt-3"
                  wight="220"
                  height="30"
                  contain
                  v-on:dblclick="removeHDR()"
                  src="/static/assets/svg/augmentablelogoblack.svg"
                  alt="augmentable"
                />
              </div>
              <div class="col-4"></div>
            </div>
          </div>
        </div>
      </show-at>
    </fullscreen>

    <!-- absolute divs -->

    <hide-at breakpoint="mediumAndBelow">
      <div>
        <v-row
          style="margin-top: 1%"
          v-bind:class="[isActive ? 'textARview' : 'textARview1']"
          no-gutters
          v-if="isActive"
        >
          <v-col cols="3" style="justify-content: flex-start; display: flex">
            <v-btn icon class="ml-5" v-on:click="hdrSettings = !hdrSettings">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Settings.svg"
              ></md-icon>
            </v-btn>
          </v-col>

          <v-col cols="6">
            <div style="text-align: center">
              <div style="display: flex; justify-content: center">
                <v-img
                  @click="changeTheme()"
                  class="mt-1"
                  wight="270"
                  height="35"
                  contain
                  v-on:dblclick="removeHDR()"
                  src="/static/assets/svg/augmentablelogowhite.svg"
                  alt="augmentable"
                />
                <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
              </div>
            </div>
          </v-col>

          <v-col
            cols="3"
            style="
              background-color: transparent;
              justify-content: flex-end;
              display: flex;
            "
          >
            <v-btn icon class="mr-3" @click="annotationNotification()">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Annotation.svg"
              >
              </md-icon>
            </v-btn>

            <v-menu
              rounded="xl"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="200"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="mr-5">
                  <!-- <v-btn icon @click="userProfile"> -->
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Manager.svg"
                  >
                  </md-icon>
                </v-btn>
              </template>
              <v-card
                class="ma-0 pa-0"
                width="200"
                height="200"
                rounded="xl"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                ><div class="pl-7 pr-7 pt-4 ma-0">
                  <p class="display-22"><strong>Profile Settings</strong></p>

                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn
                        class="ma-0 pa-0 ml-n2 mt-n1"
                        icon
                        @click="userProfile()"
                      >
                        <v-icon>mdi-account-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p
                        class="caption-11"
                        style="cursor: pointer"
                        @click="userProfile()"
                      >
                        User Profile
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                        <v-icon>mdi-upload</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p class="caption-11" style="cursor: pointer">
                        Upgrade License
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p class="caption-11" style="cursor: pointer">Help</p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn
                        class="ma-0 pa-0 ml-n2 mt-n1"
                        icon
                        @click="userLogout()"
                      >
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p
                        class="caption-11"
                        style="cursor: pointer"
                        @click="userLogout()"
                      >
                        Log Out
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                </div>
              </v-card>
            </v-menu>

            <!-- <v-btn icon @click="simpleNotification()">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Notification.svg"
              >
              </md-icon>
            </v-btn> -->
          </v-col>
        </v-row>
        <v-row
          v-bind:class="[isActive ? 'textARview' : 'textARview1']"
          no-gutters
          style="margin-top: 1%"
          v-if="!isActive"
        >
          <v-col cols="3" style="justify-content: flex-start; display: flex">
            <v-btn icon class="ml-5" v-on:click="hdrSettings = !hdrSettings">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Settings.svg"
              ></md-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <div style="display: flex; justify-content: center">
              <v-img
                @click="changeTheme()"
                class="mt-1"
                wight="270"
                height="35"
                contain
                v-on:dblclick="removeHDR()"
                src="/static/assets/svg/augmentablelogoblack.svg"
                alt="augmentable"
              />
              <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
            </div>
          </v-col>

          <!-- <v-col cols="1"></v-col> -->
          <v-col
            cols="3"
            style="
              background-color: transparent;
              justify-content: flex-end;
              display: flex;
            "
          >
            <v-btn icon class="mr-3" @click="annotationNotification()">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Annotation.svg"
              ></md-icon>
            </v-btn>
            <v-menu
              rounded="xl"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="200"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon class="mr-5" v-on="on">
                  <!-- <v-btn icon @click="userProfile"> -->
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Manager.svg"
                  ></md-icon>
                </v-btn>
              </template>
              <v-card
                class="ma-0 pa-0"
                width="200"
                height="200"
                rounded="xl"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                ><div class="pl-7 pr-7 pt-4 ma-0">
                  <p class="display-22"><strong>Profile Settings</strong></p>

                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn
                        class="ma-0 pa-0 ml-n2 mt-n1"
                        icon
                        @click="userProfile()"
                      >
                        <v-icon>mdi-account-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p
                        class="caption-11"
                        style="cursor: pointer"
                        @click="userProfile()"
                      >
                        User Profile
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                        <v-icon>mdi-upload</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p class="caption-11" style="cursor: pointer">
                        Upgrade License
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p class="caption-11" style="cursor: pointer">Help</p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                  <div class="ma-0 pa-0" style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-btn
                        class="ma-0 pa-0 ml-n2 mt-n1"
                        icon
                        @click="userLogout()"
                      >
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </div>
                    <div class="ma-0 pa-0 mt-1">
                      <p
                        class="caption-11"
                        style="cursor: pointer"
                        @click="userLogout()"
                      >
                        Log Out
                      </p>
                    </div>
                  </div>
                  <v-divider
                    class="pl-5 pr-5 mt-n3"
                    style="border-color: #d3d3d3"
                  ></v-divider>
                </div>
              </v-card>
            </v-menu>

            <!-- <v-btn icon @click="simpleNotification()">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Notification.svg"
              >
              </md-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </div>
    </hide-at>
    <!--
    <show-at breakpoint="mediumAndBelow">
      <div style="padding:0;margin:0;">
        <div v-bind:class="[isActive ? 'textARview' : 'textARview1']" style="padding:0;margin:0;">
          <div class="row">
            <div class="col-3" style="text-align:left; ">
              <v-btn icon>
                <v-icon v-on:click="hdrSettings = !hdrSettings" size="20">mdi-cog</v-icon>
              </v-btn>
            </div>
            <div class="col-6" style="text-align:center; margin: 0 auto;">
              <h1 @click="changeTheme" v-on:dblclick="removeHDR()">augmentable</h1>
            </div>
            <div class="col-3" style=" display:flex; justify-content:space-around;">
              <v-btn icon>
                <v-icon @click="annotationNotification()" size="20">mdi-moon-full</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon size="20" @click="simpleNotification()">mdi-bell</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon size="20">mdi-face</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </show-at>
    -->
    <!-- ismail showat -->
    <show-at breakpoint="mediumAndBelow">
      <div style="padding: 0; margin: 0">
        <div
          style="padding: 0; margin: 0"
          v-if="isActive"
          v-bind:class="[isActive ? 'textARview' : 'textARview1']"
        >
          <v-row no-gutters style="margin-top: 1%">
            <v-col style="text-align: center; margin: 0 auto">
              <!--
              <h1 @click="changeTheme" v-on:dblclick="removeHDR()">
                augmentable
              </h1>
              -->
              <v-img
                @click="changeTheme"
                class="mt-3"
                wight="220"
                height="30"
                contain
                v-on:dblclick="removeHDR()"
                src="/static/assets/svg/augmentablelogowhite.svg"
                alt="augmentable"
              />
            </v-col>
          </v-row>
          <v-row no-gutters style="margin: 0 auto; padding: 0">
            <v-col>
              <v-btn icon class="mt-2" @click="annotationNotification()">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/white/Annotation.svg"
                ></md-icon>
              </v-btn>
              <!-- <v-btn icon class="mt-15 ml-5 mr-5" @click="userProfile">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/white/Manager.svg"
                ></md-icon>
              </v-btn> -->
              <!-- <v-btn icon @click="simpleNotification()">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/white/Notification.svg"
                >
                </md-icon>
              </v-btn> -->
              <v-btn icon class="mt-2 ml-5" @click="userProfile">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/white/Manager.svg"
                ></md-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div
          style="padding: 0; margin: 0"
          v-if="!isActive"
          v-bind:class="[isActive ? 'textARview' : 'textARview1']"
        >
          <v-row no-gutters style="margin-top: 1%">
            <v-col style="text-align: center; margin: 0 auto">
              <!--
              <h1 @click="changeTheme" v-on:dblclick="removeHDR()">
                augmentable
              </h1>
              -->
              <v-img
                @click="changeTheme"
                class="mt-3"
                wight="220"
                height="30"
                contain
                v-on:dblclick="removeHDR()"
                src="/static/assets/svg/augmentablelogoblack.svg"
                alt="augmentable"
              />
            </v-col>
          </v-row>
          <v-row no-gutters style="margin: 0 auto; padding: 0">
            <v-col>
              <v-btn icon class="mt-2" @click="annotationNotification()">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Annotation.svg"
                ></md-icon>
              </v-btn>
              <!-- <v-btn icon class="mt-15 ml-5 mr-5" @click="userProfile">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Manager.svg"
                ></md-icon>
              </v-btn> -->
              <!-- <v-btn icon @click="simpleNotification()">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Notification.svg"
                >
                </md-icon>
              </v-btn> -->
              <v-btn icon class="mt-2 ml-5" @click="userProfile">
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Manager.svg"
                ></md-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </show-at>

    <!--

    <div v-if="simpleNotificationPosition">
      <notificationbar
        v-bind:class="[
          simplePositionDiv ? 'notifications_div' : 'notifications_div1',
        ]"
        headline="Notification"
      ></notificationbar>
    </div>
    <div v-if="annotationNotificationPosition">
      <div
        v-bind:class="[
          annotationPositionDiv ? 'notifications_div' : 'notifications_div1',
        ]"
        class="notifications_div"
      >
        <div
          style="
            text-align: right;
            padding-right: 30px;
            border-bottom: 2px solid #2b2d2f;
          "
        >
          <v-btn icon style="margin-top: -5px">
            <v-icon>mdi-moon-full</v-icon>
          </v-btn>
          <b style="font-size: 19px">Changes</b>
          <v-btn icon style="margin-top: -5px">
            <v-icon @click="isNotify = !isNotify"
              >mdi-arrow-down-bold-circle-outline</v-icon
            >
          </v-btn>
        </div>

        <div class="notify_expand" v-if="isNotify">
          <changecard
            class="mt-3"
            :doSomething1="() => fg(item.slug)"
            v-for="(item, index) in items"
            :key="index"
            :color="item.color"
            :title="item.title"
            :subtitle="item.description"
            :created="item.created_at"
          >
          </changecard>
          
          
        </div>
      </div>
    </div>
    -->

    <div v-if="simpleNotificationPosition">
      <notificationbar headline="Notification"></notificationbar>
    </div>

    <hide-at breakpoint="mediumAndBelow">
      <div
        v-if="annotationNotificationPosition"
        class="ml-6"
        style="
          position: absolute;
          top: 7%;
          left: 0;
          background-color: transparent;
        "
      >
        <div
          class="expandHot pl-1"
          style="
            background-color: transparent;
            min-height: 1vh;
            max-height: 93vh;
            direction: rtl;
          "
        >
          <div style="position: absolute; top: 0; left: 0"></div>
          <v-card
            v-if="isAnnotation"
            :style="{
              background: $vuetify.theme.themes[theme].background,
            }"
            width="330"
            height="65"
            elevation="0"
            rounded="xl"
            class="ma-0 pa-0 pb-n10"
            outlined
            style="direction: ltr"
          >
            <v-row class="ma-0 pa-0">
              <v-col cols="10">
                <v-text-field
                  id="changeDotTitle"
                  autofocus
                  v-on:keyup.enter="addAnnotationOnHotSpot()"
                  dense
                  class="ma-0 pa-0"
                  multi-line
                  v-model="annotationTitle"
                  outlined
                  rounded
                  style="border-radius: 15px"
                  label="Title"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon :style="{ color: selectColor }" v-on="on">
                      <v-icon size="30">mdi-moon-full</v-icon>
                    </v-btn>
                  </template>
                  <v-color-picker
                    mode=""
                    hide-canvas
                    show-swatches
                    v-model="selectColor"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>

          <changecard
            style="direction: ltr"
            class="mt-3"
            :doSomething1="() => fg(item.changeSpotLink)"
            :goToChangeDot="() => goingToChangeDot(item.id)"
            v-for="(item, index) in items"
            :key="index"
            :idComp="item.id"
            :color="item.color"
            :title="item.title"
            :subtitle="item.description"
            :created="item.created_at"
            :assignedTo="item.assignedTo"
            :owner="item.owner"
          >
          </changecard>
        </div>
      </div>
    </hide-at>
    <show-at breakpoint="mediumAndBelow">
      <div
        v-if="annotationNotificationPosition"
        class="ml-6"
        style="
          position: absolute;
          top: 15%;
          left: 0;
          background-color: transparent;
        "
      >
        <!-- <div
        style="
          text-align: center;
          padding-right: 30px;
          border-bottom: 2px solid #2b2d2f;
        "
      >
        <v-btn icon style="margin-top: -5px">
          <v-icon>mdi-moon-full</v-icon>
        </v-btn>
        <b
          v-if="isActive"
          style="font-size: 19px; color: white; font-family: Nunito Sans"
          >Changes</b
        >
        <b
          v-if="!isActive"
          style="font-size: 19px; color: black; font-family: Nunito Sans"
          >Changes</b
        >
        <v-btn icon style="margin-top: -5px">
          <v-icon @click="isNotify = !isNotify"
            >mdi-arrow-down-bold-circle-outline</v-icon
          >
        </v-btn>
      </div> -->
        <!-- <div class="topHot"></div> -->
        <div
          class="expandHot pl-1"
          style="
            background-color: transparent;
            min-height: 1vh;
            max-height: 85vh;
            direction: rtl;
          "
        >
          <div style="position: absolute; top: 0; left: 0"></div>
          <v-card
            v-if="isAnnotation"
            :style="{
              background: $vuetify.theme.themes[theme].background,
            }"
            width="330"
            height="65"
            elevation="0"
            rounded="xl"
            class="ma-0 pa-0 pb-n10"
            outlined
            style="direction: ltr"
          >
            <v-row class="ma-0 pa-0">
              <v-col cols="10">
                <v-text-field
                  id="changeDotTitle"
                  autofocus
                  v-on:keyup.enter="addAnnotationOnHotSpot()"
                  dense
                  class="ma-0 pa-0"
                  multi-line
                  v-model="annotationTitle"
                  outlined
                  rounded
                  style="border-radius: 15px"
                  label="Title"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon :style="{ color: selectColor }" v-on="on">
                      <v-icon size="30">mdi-moon-full</v-icon>
                    </v-btn>
                  </template>
                  <v-color-picker
                    mode=""
                    hide-canvas
                    show-swatches
                    v-model="selectColor"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>

          <changecard
            style="direction: ltr"
            class="mt-3"
            :doSomething1="() => fg(item.changeSpotLink)"
            :goToChangeDot="() => goingToChangeDot(item.id)"
            v-for="(item, index) in items"
            :key="index"
            :idComp="item.id"
            :color="item.color"
            :title="item.title"
            :subtitle="item.description"
            :created="item.created_at"
            :assignedTo="item.assignedTo"
            :owner="item.owner"
          >
          </changecard>
        </div>
      </div>
    </show-at>

    <!-- detailUI

    <div
      class="annotationpopupBack"
      @click.self.prevent="isDetailUI = !isDetailUI"
      v-if="isDetailUI"
    >
      <span class="close" @click="isDetailUI = !isDetailUI">&times;</span>
      <div class="detailedUI_div">
        <detailedUIofCard></detailedUIofCard>
      </div>
    </div>
    -->

    <div
      class="annotationpopupBack"
      @click.self.prevent="isCMS = !isCMS"
      v-if="isCMS"
    >
      <span class="close" @click="isCMS = !isCMS">&times;</span>
      <div class="bannerCMS">
        <CMS @location="location"></CMS>
      </div>
    </div>

    <!-- extra row add for spacing -->

    <!-- bottom div code -->
    <!-- ismailworking -->
    <hide-at breakpoint="mediumAndBelow">
      <v-card
        elevation="0"
        width="60"
        height="190"
        color="transparent"
        style="position: absolute; bottom: 0%; right: 1%; z-index: 100"
      >
        <div
          v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
          v-if="!isActive"
        >
          <v-row justify="center" align="center">
            <v-btn x-large @click="goToAssetsPage()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Dashboard.svg"
              ></md-icon>
            </v-btn>
          </v-row>

          <v-row justify="center" align="center">
            <v-btn x-large @click="screenShotModel()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Screenshot.svg"
              ></md-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center" class="mt-n1 mb-n1">
            <v-menu
              offset-x
              left
              rounded="lg"
              :close-on-content-click="false"
              v-model="downloadMenu"
              width="200"
            >
              <template v-slot:activator="{ on }">
                <div style="cursor: pointer" v-on="on">
                  <v-btn x-large @click="downloaddropdown1 = true" icon>
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Download.svg"
                    ></md-icon>
                  </v-btn>
                </div>
              </template>
              <v-card
                elevation="0"
                width="200"
                min-height="100"
                rounded="lg"
                class="ma-0 pa-0"
              >
                <h5 class="ml-3 pt-2" style="font-weight: 790">
                  Download Options
                </h5>
                <!-- @click="checkedOriginal()" -->
                <v-row v-if="downloadFileItems[0].title === 'Original File'">
                  <v-col cols="6">
                    <p class="ml-3" style="font-size: 11px; font-weight: 660">
                      Original File
                    </p>
                  </v-col>

                  <v-col cols="4">
                    <p
                      class="ml-1"
                      style="
                        font-size: 9px;
                        font-weight: 160;
                        color: grey;
                        margin-top: 0.3em;
                      "
                    >
                      <!-- 20mb -->
                    </p>
                  </v-col>

                  <v-col cols="2">
                    <v-checkbox
                      v-model="downloadOriginalFile"
                      class="mt-n2 ml-n7"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="mt-n10">
                  <v-col cols="6">
                    <p class="ml-3" style="font-size: 11px; font-weight: 660">
                      Viewer File
                    </p>
                  </v-col>
                  <v-col
                    cols="1"
                    style="cursor: pointer"
                    @click="downloaddropdown1 = !downloaddropdown1"
                  >
                    <v-icon class="ml-n7 mt-n2" v-if="!downloaddropdown1">
                      mdi-menu-right
                    </v-icon>
                    <v-icon class="ml-n7 mt-n2" v-if="downloaddropdown1">
                      mdi-menu-down
                    </v-icon>
                  </v-col>
                  <v-col cols="3">
                    <p
                      class="ml-n5"
                      style="
                        font-size: 9px;
                        font-weight: 160;
                        color: grey;
                        margin-top: 0.3em;
                      "
                    >
                      <!-- 04mb -->
                    </p>
                  </v-col>

                  <v-col cols="1">
                    <v-checkbox
                      style="margin-left: -2.1em"
                      class="mt-n2"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-card
                  elevation="0"
                  v-if="downloaddropdown1"
                  width="195"
                  color="transparent"
                  class="mt-2"
                >
                  <v-row
                    class="mb-n2"
                    v-for="(item, index) in computedDownloadFileItems"
                    :key="index"
                  >
                    <!-- @click="checkExportFiles(item, index)" -->
                    <v-row
                      v-if="item.value !== 'original' && item.value !== 'draco'"
                      class="mt-n8"
                    >
                      <v-col cols="1" class="ml-5">
                        <md-icon
                          v-if="augmentableTheme"
                          class="md-size-x"
                          style="cursor: pointer"
                          :md-src="item.svg1"
                        />
                        <md-icon
                          v-if="!augmentableTheme"
                          class="md-size-x"
                          style="cursor: pointer"
                          :md-src="item.svg2"
                        />
                      </v-col>
                      <v-col cols="6">
                        <p
                          class="caption-11 mt-1 ml-2"
                          style="
                            font-weight: 700;
                            opacity: 0.8;
                            cursor: pointer;
                          "
                        >
                          {{ item.title }}
                        </p>
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox
                          v-model="item.checked"
                          @click="checkExportValues(item, index)"
                          class="mt-n1 ml-1"
                        ></v-checkbox>
                      </v-col>
                      <!-- <v-col cols="1"> </v-col> -->
                    </v-row>
                  </v-row>
                </v-card>
                <v-row align="center" justify="center" class="mt-n11">
                  <v-btn x-large @click="downloadFiles" icon>
                    <md-icon
                      v-model="downloadMenu"
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Download.svg"
                    ></md-icon>
                  </v-btn>
                </v-row>
              </v-card>
              <!-- <v-list>
                <v-list-item
                  v-for="(item, index) in downloadFileItems"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="item.value"
                      :label="item.title"
                    ></v-checkbox>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-btn @click="downloadFiles" icon>
                      <md-icon
                        v-model="downloadMenu"
                        class="md-size-1x"
                        md-src="/static/assets/svg/black/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-menu>
          </v-row>
          <v-row justify="center" align="center">
            <v-btn x-large icon @click="toggleFullScreen">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/Fullscreen.svg"
              ></md-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center">
            <v-btn @click="openARwindow()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/black/ARViewer.svg"
              ></md-icon>
            </v-btn>
          </v-row>
        </div>
        <div
          v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
          v-if="isActive"
        >
          <v-row justify="center" align="center">
            <v-btn x-large @click="goToAssetsPage()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Dashboard.svg"
              ></md-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center">
            <v-btn x-large @click="screenShotModel()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Screenshot.svg"
              ></md-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center" class="mt-n1 mb-n1">
            <v-menu
              offset-x
              left
              top
              rounded="lg"
              :close-on-content-click="false"
              v-model="downloadMenu"
              width="200"
            >
              <template v-slot:activator="{ on }">
                <div style="cursor: pointer" v-on="on">
                  <v-btn x-large @click="downloaddropdown1 = true" icon>
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/white/Download.svg"
                    ></md-icon>
                  </v-btn>
                </div>
              </template>
              <v-card
                elevation="0"
                width="200"
                min-height="100"
                rounded="lg"
                class="ma-0 pa-0"
              >
                <h5 class="ml-3 pt-2" style="font-weight: 790">
                  Download Options
                </h5>
                <!-- @click="checkedOriginal()" -->
                <v-row v-if="downloadFileItems[0].title === 'Original File'">
                  <v-col cols="6">
                    <p class="ml-3" style="font-size: 11px; font-weight: 660">
                      Original File
                    </p>
                  </v-col>

                  <v-col cols="4">
                    <p
                      class="ml-1"
                      style="
                        font-size: 9px;
                        font-weight: 160;
                        color: grey;
                        margin-top: 0.3em;
                      "
                    >
                      <!-- 20mb -->
                    </p>
                  </v-col>

                  <v-col cols="2">
                    <v-checkbox
                      v-model="downloadOriginalFile"
                      class="mt-n2 ml-n7"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="mt-n10">
                  <v-col cols="6">
                    <p class="ml-3" style="font-size: 11px; font-weight: 660">
                      Viewer File
                    </p>
                  </v-col>
                  <v-col
                    cols="1"
                    style="cursor: pointer"
                    @click="downloaddropdown1 = !downloaddropdown1"
                  >
                    <v-icon class="ml-n7 mt-n2" v-if="!downloaddropdown1">
                      mdi-menu-right
                    </v-icon>
                    <v-icon class="ml-n7 mt-n2" v-if="downloaddropdown1">
                      mdi-menu-down
                    </v-icon>
                  </v-col>
                  <v-col cols="3">
                    <p
                      class="ml-n5"
                      style="
                        font-size: 9px;
                        font-weight: 160;
                        color: grey;
                        margin-top: 0.3em;
                      "
                    >
                      <!-- 04mb -->
                    </p>
                  </v-col>

                  <v-col cols="1">
                    <v-checkbox
                      v-model="filebtns[0].checked"
                      style="margin-left: -2.1em"
                      class="mt-n2"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-card
                  elevation="0"
                  v-if="downloaddropdown1"
                  width="195"
                  color="transparent"
                  class="mt-2"
                >
                  <v-row
                    class="mb-n2"
                    v-for="(item, index) in computedDownloadFileItems"
                    :key="index"
                  >
                    <!-- @click="checkExportFiles(item, index)" -->
                    <v-row
                      v-if="item.value !== 'original' && item.value !== 'draco'"
                      class="mt-n8"
                    >
                      <v-col cols="1" class="ml-5">
                        <md-icon
                          v-if="augmentableTheme"
                          class="md-size-x"
                          style="cursor: pointer"
                          :md-src="item.svg1"
                        />
                        <md-icon
                          v-if="!augmentableTheme"
                          class="md-size-x"
                          style="cursor: pointer"
                          :md-src="item.svg2"
                        />
                      </v-col>
                      <v-col cols="6">
                        <p
                          class="caption-11 mt-1 ml-2"
                          style="
                            font-weight: 700;
                            opacity: 0.8;
                            cursor: pointer;
                          "
                        >
                          {{ item.title }}
                        </p>
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox
                          v-model="item.checked"
                          @click="checkExportValues(item, index)"
                          class="mt-n1 ml-1"
                        ></v-checkbox>
                      </v-col>
                      <!-- <v-col cols="1"> </v-col> -->
                    </v-row>
                  </v-row>
                </v-card>
                <v-row align="center" justify="center" class="mt-n9">
                  <v-btn x-large @click="downloadFiles" icon>
                    <md-icon
                      v-model="downloadMenu"
                      class="md-size-2x"
                      md-src="/static/assets/svg/white/Download.svg"
                    ></md-icon>
                  </v-btn>
                </v-row>
              </v-card>
              <!-- <v-list>
                <v-list-item
                  v-for="(item, index) in downloadFileItems"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="item.value"
                      :label="item.title"
                    ></v-checkbox>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-btn @click="downloadFiles" icon>
                      <md-icon
                        v-model="downloadMenu"
                        class="md-size-2x"
                        md-src="/static/assets/svg/white/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-menu>
          </v-row>
          <v-row justify="center" align="center">
            <v-btn x-large icon @click="toggleFullScreen">
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/Fullscreen.svg"
              ></md-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center">
            <v-btn @click="openARwindow()" icon>
              <md-icon
                class="md-size-2x"
                md-src="/static/assets/svg/white/ARViewer.svg"
              ></md-icon>
            </v-btn>
          </v-row>
        </div>
      </v-card>
    </hide-at>
    <!--
    <show-at breakpoint="mediumAndBelow">
      <div v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']">
        <div class="row">
          <div
            class="col-4"
            style="background-color:transparent; display:flex; justify-content:space-around;"
          >
            <v-btn icon>
              <v-icon @click="openCMSBig()" size="20">mdi-folder</v-icon>
            </v-btn>
            
            <v-btn icon>
              <v-icon @click="screenShotModel()" size="20">mdi-camera</v-icon>
            </v-btn>
          </div>
          <div class="col-4">
            <div style="text-align:center; font-size: 21px;">{{fileName}}</div>
            <div style="text-align:center; font-size: 11px;">{{version}}</div>
          </div>
          <div
            class="col-4"
            style="background-color:transparent; display:flex; justify-content:space-around;"
          >
            <v-menu absolute offset-y :close-on-content-click="false" v-model="downloadMenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon size="20">mdi-download</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item v-for="(item, index) in downloadFileItems" :key="index">
                  <v-list-item-content>
                    <v-checkbox
                      style="margin-left:15px;"
                      id="cbox11"
                      v-model="item.value"
                      :label="item.title"
                    ></v-checkbox>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-btn icon>
                      <v-icon @click="downloadFiles" v-model="downloadMenu" size="20">mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            
            <v-btn icon>
              <v-icon @click="toggleFullScreen" size="20">mdi-fullscreen</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon @click="openARwindow" size="20">mdi-axis-arrow</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </show-at>
    -->

    <!-- ismail bottom div mediumand below show -->
    <show-at breakpoint="mediumAndBelow">
      <div>
        <hide-at breakpoint="small">
          <div>
            <v-row
              v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
              v-if="isActive"
              no-gutters
              style="margin-left: 10%; padding: 0; height: 60px; width: 80%"
            >
              <v-col
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Screenshot.svg"
                  ></md-icon>
                </v-btn>

                <v-menu
                  absolute
                  rounded="xl"
                  offset-y
                  :close-on-content-click="false"
                  v-model="downloadMenu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/white/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in downloadFileItems"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-checkbox
                          style="margin-left: 15px"
                          id="cbox11"
                          v-model="item.value"
                          :label="item.title"
                        ></v-checkbox>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-btn @click="downloadFiles" icon>
                          <md-icon
                            v-model="downloadMenu"
                            class="md-size-2x"
                            md-src="/static/assets/svg/white/Download.svg"
                          ></md-icon>
                        </v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col>
                <!-- <div style="text-align: center; font-size: 21px">
                  {{ fileName }}
                </div>
                <div style="text-align: center; font-size: 11px">
                  {{ version }}
                </div> -->
              </v-col>
              <v-col
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn icon @click="toggleFullScreen">
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Fullscreen.svg"
                  ></md-icon>
                </v-btn>

                <v-btn @click="openARwindow" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
              v-if="!isActive"
              no-gutters
              style="margin-left: 10%; padding: 0; height: 60px; width: 80%"
            >
              <v-col
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Screenshot.svg"
                  ></md-icon>
                </v-btn>

                <v-menu
                  absolute
                  rounded="xl"
                  offset-y
                  :close-on-content-click="false"
                  v-model="downloadMenu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/black/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in downloadFileItems"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-checkbox
                          style="margin-left: 15px"
                          id="cbox11"
                          v-model="item.value"
                          :label="item.title"
                        ></v-checkbox>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-btn @click="downloadFiles" icon>
                          <md-icon
                            v-model="downloadMenu"
                            class="md-size-2x"
                            md-src="/static/assets/svg/black/Download.svg"
                          ></md-icon>
                        </v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col>
                <!-- <div style="text-align: center; font-size: 21px">
                  {{ fileName }}
                </div>
                <div style="text-align: center; font-size: 11px">
                  {{ version }}
                </div> -->
              </v-col>
              <v-col
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn icon @click="toggleFullScreen">
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Fullscreen.svg"
                  ></md-icon>
                </v-btn>

                <v-btn @click="openARwindow" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </hide-at>
        <show-at breakpoint="small">
          <div>
            <div
              v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
              v-if="isActive"
              no-gutters
              class="horizontolButton"
              style="
                margin: 0;
                padding: 0;
                height: 60px;
                width: 100%;
                display: flex;
              "
            >
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn icon @click="toggleFullScreen">
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Fullscreen.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <!-- small devices was showing this and changing the layout -->
              <!--
              <v-col>
                
                <div style="text-align: center; font-size: 21px">
                  {{ fileName }}
                </div>
                <div style="text-align: center; font-size: 11px">
                  {{ version }}
                </div>
               
              </v-col>
               -->
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
                ><v-btn @click="openARwindow" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>

              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/white/Screenshot.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-menu
                  absolute
                  rounded="xl"
                  offset-y
                  :close-on-content-click="false"
                  v-model="downloadMenu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/white/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in downloadFileItems"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-checkbox
                          style="margin-left: 15px"
                          id="cbox11"
                          v-model="item.value"
                          :label="item.title"
                        ></v-checkbox>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-btn @click="downloadFiles" icon>
                          <md-icon
                            v-model="downloadMenu"
                            class="md-size-2x"
                            md-src="/static/assets/svg/white/Download.svg"
                          ></md-icon>
                        </v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </div>
            <div
              v-bind:class="[isActive ? 'file_name_div' : 'file_name_div1']"
              v-if="!isActive"
              no-gutters
              class="horizontolButton"
              style="
                margin: 0;
                padding: 0;
                height: 60px;
                width: 100%;
                display: flex;
              "
            >
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn icon @click="toggleFullScreen">
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Fullscreen.svg"
                  ></md-icon>
                </v-btn>
              </v-col>
              <!-- small devices was showing this and changing the layout -->
              <!--
              <v-col>
                
                <div style="text-align: center; font-size: 21px">
                  {{ fileName }}
                </div>
                <div style="text-align: center; font-size: 11px">
                  {{ version }}
                </div>
               
              </v-col>
               -->
              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
                ><v-btn @click="openARwindow" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/ARViewer.svg"
                  ></md-icon>
                </v-btn>
              </v-col>

              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-btn @click="screenShotModel()" icon>
                  <md-icon
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Screenshot.svg"
                  ></md-icon>
                </v-btn>
              </v-col>

              <v-col
                cols="4"
                style="
                  background-color: transparent;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <v-menu
                  absolute
                  rounded="xl"
                  offset-y
                  :close-on-content-click="false"
                  v-model="downloadMenu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/black/Download.svg"
                      ></md-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in downloadFileItems"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-checkbox
                          style="margin-left: 15px"
                          id="cbox11"
                          v-model="item.value"
                          :label="item.title"
                        ></v-checkbox>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-btn @click="downloadFiles" icon>
                          <md-icon
                            v-model="downloadMenu"
                            class="md-size-2x"
                            md-src="/static/assets/svg/black/Download.svg"
                          ></md-icon>
                        </v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </div>
          </div>
        </show-at>
      </div>
    </show-at>

    <!-- <div
      class="annotationpopupBack"
      @click.self.prevent="isAnnotation = !isAnnotation"
      v-if="isAnnotation"
    >
      <v-card
        width="300"
        height="350"
        :style="{ background: $vuetify.theme.themes[theme].background }"
        style="border-radius: 20px"
        class="annotationpop"
      >
        <v-form ref="form" v-model="form" class="pa-10">
          <v-text-field
            multi-line
            v-model="annotationTitle"
            outlined
            rounded
            style="border-radius: 15px"
            label="Title"
          ></v-text-field>
          <v-textarea
            style="margin-top: -25px; border-radius: 15px"
            outlined
            auto-grow
            v-model="annotationText"
            label="Change"
            rows="4"
            row-height="25"
            rounded="15px"
          ></v-textarea>
          <v-row align="center" justify="center">
            <v-col cols="1"></v-col>
            <v-col cols="5" style="text-align: center">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="my-2">
                    <v-btn icon :style="{ color: selectColor }" v-on="on">
                      <v-icon size="40">mdi-moon-full</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-color-picker
                  mode=""
                  hide-canvas
                  show-swatches
                  v-model="selectColor"
                ></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="5">
              <v-btn @click="addAnnotationOnHotSpot()" fab size="10">
                OK
              </v-btn>
              
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-form>
      </v-card>
    </div> -->

    <!--
    <div
      class="annotationpopupBack"
      @click.self.prevent="isAnnotation = !isAnnotation"
      v-if="isAnnotation21"
    >
      <div class="annotationpopupb">
        <span class="close" @click="isAnnotation = !isAnnotation">&times;</span>

        <v-form class="annotationpopup" ref="form" v-model="form">
          <v-text-field
            multi-line
            v-model="annotationTitle"
            outlined
            label="Title"
          ></v-text-field>
          <v-textarea
            style="margin-top: -25px"
            outlined
            auto-grow
            v-model="annotationText"
            label="Annotation"
            rows="4"
            row-height="25"
            shaped
          ></v-textarea>
          <v-row align="center" justify="center">
            <v-col cols="1"></v-col>
            <v-col cols="5" style="text-align: center">
              <v-menu
                
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="my-2">
                    <v-btn icon :style="{ color: selectColor }" v-on="on">
                      <v-icon size="40">mdi-moon-full</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-color-picker v-model="selectColor"></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="5">
              <v-btn @click="addAnnotationOnHotSpot()" fab size="10">
                OK
              </v-btn>
              
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    -->

    <!-- start viewer settings component -->
    <div v-if="hdrSettings" class="hdrNavigation ml-10 mt-10">
      <v-container style="margin: 0; padding: 0">
        <v-card
          width="253"
          elevation="3"
          min-height="390"
          style="border-radius: 15px"
          :style="{ background: $vuetify.theme.themes[theme].background }"
        >
          <v-layout>
            <v-flex>
              <v-card
                width="30"
                elevation="0"
                height="426"
                class="ml-1"
                :style="{ background: $vuetify.theme.themes[theme].background }"
              >
                <!-- 1st btn -->
                <div class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0 mt-n3 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="lightf()">
                        mdi-lightbulb-on-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 2nd btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="circlef()"> tonality </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 3rd btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="mediaf()">
                        mdi-play-circle-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 4th btn -->
                  <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn @click="colorbtnf()" icon>
                      <v-icon size="22"> mdi-palette-outline </v-icon>
                    </v-btn>
                  </v-row> -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="boxbtnf()">
                            mdi-palette-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>

                  <!-- 5th btn -->
                  <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn @click="boxbtnf()" icon>
                      <v-icon size="22"> mdi-texture </v-icon>
                    </v-btn>
                  </v-row> -->
                  <!-- 6th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="filebtnf()">
                            description
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                  <!-- 7th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="photobtnf()">
                            photo_size_select_large
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                  <!-- 8th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                    <v-btn icon>
                      <v-icon size="22" @click="camerabtnf()">
                        mdi-camera-outline
                      </v-icon>
                    </v-btn>
                  </v-row>

                  <!-- 9th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="addVersionToServer()">
                            mdi-content-duplicate
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>New Version</span>
                    </v-tooltip>
                  </v-row>

                  <!-- 10th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="saveFileConfig()">
                        mdi-auto-upload
                      </v-icon>
                    </v-btn>
                  </v-row>

                  <!-- 11th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22"> mdi-undo </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                </div>
              </v-card>
            </v-flex>

            <v-divider
              class="mt-2 mb-5"
              style="border-color: #d3d3d3"
              vertical
            ></v-divider>

            <v-flex>
              <!-- 1st card -->
              <v-card
                v-if="lightbutton"
                width="170"
                elevation="0"
                min-height="325"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-4 ml-2"
              >
                <h4 class="ml-3">Enviorment</h4>
                <p class="ml-3" style="font-size: 11px; font-weight: 650">
                  Active HDR (Share Page)
                </p>

                <v-select
                  :items="hdrFileItems"
                  v-model="hdrItem"
                  item-text="file_name"
                  item-value="file_hdr"
                  dense
                  class="ml-1"
                  rounded
                  outlined
                  @input="hdrSelectActive(hdrItem)"
                >
                </v-select>

                <v-row>
                  <v-col cols="9">
                    <h5 style="margin-top: -1.8em">Use Enviorment as skyBox</h5>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox v-model="asSkybox" style="margin-top: -1.6em">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="9">
                    <h5 style="margin-top: -1.8em">Neutral Light</h5>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="neutralLight"
                      style="margin-top: -1.6em"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <h5 style="margin-top: -1.2em">HDRI light rotation</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider>
                <h5 style="margin-top: -1.5em">Brightness</h5>
                <v-slider
                  v-model="hdrExposure"
                  thumb-label
                  min="0"
                  max="2"
                  step="0.1"
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider>
                <!-- <h5 style="margin-top: -1.6em">Brightness</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
                <v-row class="mt-n8">
                  <v-col cols="6">
                    <p>HDR List</p>
                  </v-col>
                  <v-col cols="3">
                    <v-icon
                      @click="hdrlist = !hdrlist"
                      color="blue"
                      class="ml-n5"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                  <v-col cols="2">
                    <v-icon size="22" @click="addHDR()">mdi-plus</v-icon>
                  </v-col>
                </v-row>
                <div v-if="hdrlist">
                  <v-card
                    elevation="0"
                    height="130"
                    class="expand mt-n3"
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                  >
                    <v-card-text>
                      <div v-for="(item, index) in hdrFileItems" :key="index">
                        <v-row class="ma-0 pa-0">
                          <v-col cols="8">
                            <p
                              style="cursor: pointer"
                              @click="hdrSelect(item.file_hdr)"
                            >
                              {{ item.file_name }}
                            </p>
                          </v-col>
                          <v-col cols="4">
                            <v-btn icon @click="deleteHDR(item.id)">
                              <v-icon> mdi-delete-outline </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-divider
                          style="border-color: #d3d3d3"
                          class="ml-2 mr-2"
                        ></v-divider>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-card>

              <!-- 2nd card -->
              <v-card
                v-if="circlebutton"
                width="170"
                elevation="0"
                height="325"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-n3 ml-2"
              >
                <p
                  class="caption-11 mt-8"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Shadow Intensity
                </p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="shadowIntensity"
                    min="0.0"
                    step="0.5"
                    max="10.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n5"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedShadowIntensity }}
                    <v-btn icon>
                      <v-icon> mdi-undo </v-icon>
                    </v-btn>
                  </p>
                </div>
                <p
                  class="caption-11 mt-n3"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Shadow Softness
                </p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="shadowSoftness"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n5"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedShadowSoftness }}
                    <v-btn icon>
                      <v-icon> mdi-undo </v-icon>
                    </v-btn>
                  </p>
                </div>

                <!-- <p
                  class="caption-11 mt-n3"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Contrast
                </p>
                <v-slider
                  class="mt-n5"
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
                <!-- <p
                  class="caption-11 mt-n3"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Saturation
                </p>
                <v-slider
                  class="mt-n5"
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
                <div style="display: flex" class="mt-n3">
                  <p>Wireframe</p>
                  <v-checkbox class="mt-n2 ml-8"></v-checkbox>
                </div>
                <div style="display: flex" class="mt-n3">
                  <p>Shaded</p>
                  <v-checkbox class="mt-n2 ml-13"></v-checkbox>
                </div>
                <div style="display: flex" class="mt-n3">
                  <p>Double Sided</p>
                  <v-checkbox class="mt-n2 ml-4"></v-checkbox>
                </div>
              </v-card>

              <!-- 3 card -->
              <v-card
                v-if="mediabutton"
                width="170"
                elevation="0"
                min-height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <!-- <v-row>
                  <v-col cols="9">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Enable turnable
                    </p>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="glbRotation"
                      style="margin-top: -0.5em"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row style="margin-top: -3em">
                  <v-col cols="1">
                    <v-icon @click="directionClockWise = true">
                      mdi-axis-z-rotate-counterclockwise
                    </v-icon>
                  </v-col>
                  <v-col cols="1">
                    <v-icon @click="directionClockWise = false">
                      mdi-axis-z-rotate-clockwise
                    </v-icon>
                  </v-col>
                </v-row>
                <p
                  class="caption-11 mt-n1 mb-n1"
                  style="font-weight: 600; opacity: 0.8"
                >
                  Speed of Turnable
                </p>
                <v-slider
                  v-model="speedAndDirectionOfModel"
                  min="20"
                  max="800"
                  step="5"
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->

                <!-- Animation Settings -->
                <div class="ma-0 pa-0 mt-5">
                  <p class="ml-1 caption-11">
                    Animation Settings<v-icon
                      v-if="!animationAnimationSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationAnimationSettings = !animationAnimationSettings
                      "
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="animationAnimationSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationAnimationSettings = !animationAnimationSettings
                      "
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div
                  class="ma-0 pa-0 mt-n2 ml-2"
                  v-if="animationAnimationSettings"
                >
                  <p style="font-size: 11px">Base Animation</p>
                  <v-row class="mt-n4 mr-1">
                    <v-select
                      :items="animationList"
                      v-model="animationSelect"
                      dense
                      outlined
                      class="ml-2"
                      rounded
                      @input="animationSelected(animationSelect)"
                    >
                    </v-select>
                  </v-row>

                  <div
                    class="ma-0 pa-0 mx-2 mt-n3"
                    v-for="(item, index) in selectedAnimationList"
                    :key="index"
                  >
                    <div style="display: flex; font-size: 11px">
                      <div class="ma-0 pa-0">
                        <p class="mr-3">{{ index + 1 }}.</p>
                      </div>
                      <div class="ma-0 pa-0">
                        <p>
                          {{ item }}
                        </p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0 mr-1">
                        <v-icon
                          size="15"
                          @click="removeSelectedAnimationList(index)"
                          >mdi-close</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0">
                        <v-icon size="15">mdi-drag</v-icon>
                      </div>
                    </div>
                  </div>

                  <v-row justify="center" class="ma-0 pa-0 mt-n2">
                    <v-menu
                      rounded="lg"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      bottom
                      max-width="200"
                    >
                      <template v-slot:activator="{ on }">
                        <p
                          style="
                            font-size: 11px;
                            color: #419cff;
                            cursor: pointer;
                          "
                          v-on="on"
                        >
                          Select Animationclip<v-icon
                            size="15"
                            class="ml-2"
                            color="primary"
                            >mdi-plus</v-icon
                          >
                        </p>
                      </template>

                      <v-card
                        class="ma-0 pa-0"
                        width="200"
                        height="200"
                        rounded="lg"
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        ><div class="pl-7 pr-7 pt-2 ma-0">
                          <p class="display-22">
                            <strong>Animation Clips</strong>
                          </p>

                          <v-card
                            elevation="0"
                            width="200"
                            height="145"
                            style="overflow-x: hidden"
                            class="ma-0 pa-0 mt-n2 mb-2 expand"
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                          >
                            <div
                              class="ma-0 pa-0"
                              v-for="(
                                item, index
                              ) in computedSelectedAnimationList"
                              :key="index"
                            >
                              <div
                                class="ma-0 pa-0 mt-1 mb-n2"
                                style="display: flex; justify-content: start"
                              >
                                <p
                                  style="cursor: pointer"
                                  class="caption-11"
                                  @click="selectedAnimationListFunc(item)"
                                >
                                  {{ item }}
                                </p>
                              </div>
                              <v-divider
                                class="pl-5 pr-5 mt-n3"
                                style="border-color: #d3d3d3"
                              ></v-divider>
                            </div>
                          </v-card>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-row>
                </div>

                <!-- Blend Animation -->
                <div class="ma-0 pa-0">
                  <p class="ml-1 caption-11">
                    Blend Animations<v-icon
                      v-if="!animationBlendAnimations"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationBlendAnimations = !animationBlendAnimations
                      "
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="animationBlendAnimations"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationBlendAnimations = !animationBlendAnimations
                      "
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div
                  class="ma-0 pa-0 ml-2 mr-1"
                  v-if="animationBlendAnimations"
                >
                  <div style="display: flex" class="mt-n1">
                    <div class="ma-0 pa-0">
                      <p style="font-size: 10px">Combine animation</p>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="ma-0 pa-0">
                      <v-checkbox
                        v-model="animationCombined"
                        class="mt-n2 mr-n2"
                      >
                      </v-checkbox>
                    </div>
                  </div>
                  <v-row class="mt-n4">
                    <v-select
                      :items="animationList2nd"
                      v-model="animationSelect2nd"
                      dense
                      class="ml-2"
                      rounded
                      outlined
                      @input="insertOtherAnimationSelected(animationSelect2nd)"
                    >
                    </v-select>
                  </v-row>
                </div>
                <!-- Animation Controls -->
                <v-card
                  width="170"
                  elevation="0"
                  rounded="lg"
                  min-height="30"
                  class="ma-0 pa-0 ml-1 mt-3 pl-2 pb-2 pt-2 pr-2 mb-4"
                  v-bind:color="isActive ? '#808080' : '#e0e0e0'"
                >
                  <v-card
                    width="170"
                    elevation="0"
                    rounded="lg"
                    height="20"
                    class="ma-0 pa-0 mb-n2"
                    v-bind:color="isActive ? '#808080' : '#e0e0e0'"
                  >
                    <div class="ma-0 pa-0" style="display: flex">
                      <div class="ma-0 pa-0">
                        <p style="font-size: 10px">Animation Controls</p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0 mt-n1">
                        <v-icon
                          v-if="!animationAnimationControls"
                          class="ml-3"
                          size="22"
                          color="primary"
                          @click="
                            animationAnimationControls =
                              !animationAnimationControls
                          "
                          >mdi-menu-right</v-icon
                        >
                        <v-icon
                          v-if="animationAnimationControls"
                          class="ml-3"
                          size="22"
                          color="primary"
                          @click="
                            animationAnimationControls =
                              !animationAnimationControls
                          "
                          >mdi-menu-down</v-icon
                        >
                      </div>
                    </div>
                  </v-card>

                  <div class="ma-0 pa-0 mt-3" v-if="animationAnimationControls">
                    <div class="ma-0 pa-0">
                      <p class="caption-11 mt-n2 mb-n1">Animation Speed</p>
                      <v-slider
                        min="20"
                        max="800"
                        step="5"
                        thumb-label
                        track-color="grey"
                        track-fill-color="grey"
                      >
                      </v-slider>
                    </div>
                    <div
                      class="ma-0 pa-0 mt-n6"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="ma-0 pa-0 mt-2">
                        <v-icon size="20" @click="playPreviousAnimation()"
                          >mdi-skip-previous</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0" v-if="!glbAnimationButton">
                        <v-icon size="35" @click="glbAnimation = !glbAnimation"
                          >mdi-play-circle-outline</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0" v-if="glbAnimationButton">
                        <v-icon
                          size="35"
                          color="primary"
                          @click="glbAnimation = !glbAnimation"
                          >mdi-pause</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2">
                        <v-icon size="20" @click="playNextAnimation()"
                          >mdi-skip-next</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2" v-if="animationLoopButton">
                        <v-icon
                          size="15"
                          color="primary"
                          @click="animationLoop = !animationLoop"
                          >mdi-sync</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2" v-if="!animationLoopButton">
                        <v-icon
                          size="15"
                          @click="animationLoop = !animationLoop"
                          >mdi-sync</v-icon
                        >
                      </div>
                    </div>
                  </div>
                </v-card>
                <!-- <div style="display: flex" class="ma-0 pa-0 mt-3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Enable animation
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="glbAnimation" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <div style="display: flex" class="mt-n3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Loop
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="animationLoop" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <p
                  class="caption-11 mt-n3"
                  style="font-weight: 600; opacity: 0.8"
                >
                  Active Animation
                </p>
                <v-row class="mt-n2">
                  <v-select
                    :items="animationList"
                    v-model="animationSelect"
                    dense
                    class="ml-2"
                    rounded
                    outlined
                    @input="animationSelected(animationSelect)"
                  >
                  </v-select>
                </v-row>
                <div style="display: flex" class="mt-n3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Combine animation
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="animationCombined" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <v-row class="mt-n2">
                  <v-select
                    :items="animationList2nd"
                    v-model="animationSelect2nd"
                    dense
                    class="ml-2"
                    rounded
                    outlined
                    @input="insertOtherAnimationSelected(animationSelect2nd)"
                  >
                  </v-select>
                </v-row> -->

                <!-- <h5 style="margin-top: -0.9em">Speed</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
              </v-card>

              <!-- 4 card -->

              <v-card
                v-if="colorbtncard"
                width="180"
                elevation="0"
                height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <v-flex class="ma-0 pa-0">
                  <v-avatar
                    class="mt-4 mr-4 ml-4"
                    v-for="(item, index) in itemscolor"
                    :key="index"
                    :color="item.color"
                    @click="colorf(item)"
                    size="16"
                  ></v-avatar>
                </v-flex>
              </v-card>

              <!-- 5 card -->
              <v-card
                v-if="boxbtncard"
                width="170"
                elevation="0"
                min-height="370"
                max-height="500"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2 expand"
              >
                <v-row class="">
                  <v-col cols="7">
                    <p class="caption-11 pl-2">Materials</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon class="mt-n2">search</v-icon>
                  </v-col>
                  <v-col cols="1">
                    <v-menu offset-y left min-width="145" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="mt-n2 ml-1"
                          v-on="on"
                          size="20"
                          color="black"
                          >mdi-plus</v-icon
                        >
                      </template>
                      <v-card
                        elevation="4"
                        width="145"
                        class="ma-0 pa-0"
                        height="107"
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        rounded="lg"
                      >
                        <div style="display: flex" class="pl-2 pt-2">
                          <v-icon>mdi-content-copy</v-icon>
                          <p style="font-weight: 450" class="pt-2 pl-2">
                            Duplicate
                          </p>
                        </div>
                        <v-divider
                          style="border-color: #d3d3d3"
                          class="ml-2 mr-2"
                        ></v-divider>
                        <div style="display: flex" class="pl-2 pt-1">
                          <v-icon class="mt-n2">mdi-plus</v-icon>
                          <p style="font-weight: 450" class="ml-2 mt-1">
                            Create new
                          </p>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="1"> </v-col>
                </v-row>
                <p
                  class="ml-2 mt-n6"
                  style="font-weight: 400 !important; font-size: 10px"
                >
                  Select Material
                </p>

                <v-select
                  return-object
                  :items="modelMaterials"
                  v-model="currentMaterial"
                  item-text="name"
                  item-value="id"
                  background-color="#F5F5F5"
                  solo
                  dense
                  style="border-radius: 1.5em !important"
                  label="material"
                  class="ml-1 mr-2 mt-n3 mb-n5"
                >
                </v-select>

                <v-row class="ml-1 mt-n6">
                  <v-col cols="8">
                    <p class="caption-11">Transparency</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="transparency = !transparency"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="transparency" class="mt-n6">
                  <p style="font-size: 10px; font-weight: 500" class="ml-5">
                    Transparency Mode
                  </p>

                  <v-select
                    :items="items"
                    solo
                    dense
                    background-color="#F5F5F5"
                    label="material"
                    class="mb-n6 mt-n3 mr-2"
                    style="border-radius: 1.5em !important"
                  >
                  </v-select>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="mt-2 ml-5"
                  >
                    Alpha Mode
                  </p>
                  <div>
                    <v-select
                      :items="items"
                      solo
                      dense
                      style="border-radius: 1.5em !important"
                      background-color="#F5F5F5"
                      label="material"
                      class="mb-n6 mt-n3 mr-2"
                    >
                    </v-select>
                  </div>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="mt-2 ml-5"
                  >
                    Alpha
                  </p>
                  <v-slider
                    class="mt-n5"
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <div style="display: flex" class="mt-n8 mb-n4">
                    <v-list
                      :style="{
                        background: $vuetify.theme.themes[theme].background,
                      }"
                    >
                      <v-list-item style="font-size: 11px !important">
                        Use alpha from albedo texture
                      </v-list-item>
                    </v-list>
                    <v-checkbox></v-checkbox>
                  </div>
                </div>
                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Base Color</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="baseColor = !baseColor"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>

                <div v-if="baseColor" class="mt-n6">
                  <div style="display: flex; align-items: center">
                    <v-menu
                      offset-y
                      width="250"
                      min-height="250"
                      max-height="500"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="50"
                          height="50"
                          class="mt-2 ml-5"
                        >
                          <v-img
                            :src="materialTextures.baseColorTexture"
                            width="50"
                            height="50"
                            contain
                            ratio="1"
                          ></v-img>
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="250"
                        min-height="250"
                        max-height="500"
                        color="#F5F5F5"
                        class="ma-0 pa-0 expand"
                      >
                        <div
                          class="ma-0 pa-0 mb-n8"
                          style="display: flex; justify-content: end"
                        >
                          <v-btn icon @click="inputFileClick('1')">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <input
                            type="file"
                            id="inputTexture1"
                            style="display: none"
                            @change="changeTexture('1')"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            -webkit-flex-wrap: wrap;
                            flex-wrap: wrap;
                          "
                        >
                          <div
                            class="ml-4 mb-n8"
                            v-for="(item, index) in materialTexturesSelection"
                            :key="index"
                          >
                            <v-card
                              v-on="on"
                              elevation="0"
                              width="50"
                              height="50"
                              v-if="item"
                              @click="
                                applyTextureToModel(item, 'baseColorTexture')
                              "
                            >
                              <v-img
                                :src="item"
                                width="50"
                                height="50"
                                contain
                                ratio="1"
                              ></v-img>
                            </v-card>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Texture
                    </p>
                  </div>
                  <div style="display: flex; align-items: center" class="mb-4">
                    <v-menu
                      offset-y
                      min-width="100"
                      rounded="lg"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="2"
                          width="50"
                          height="50"
                          :color="baseColorFactor"
                          class="mt-2 ml-5"
                        >
                        </v-card>
                      </template>
                      <color-picker
                        theme="light"
                        :color="baseColorFactor"
                        :sucker-hide="false"
                        :sucker-canvas="suckerCanvas"
                        :sucker-area="suckerArea"
                        @changeColor="changeBaseColor"
                      />
                      <!-- <v-color-picker
                        mode="rgba"
                        v-model="baseColorFactor"
                      ></v-color-picker> -->
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Factor
                    </p>
                  </div>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Metallic Roughness</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="metalness = !metalness"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="metalness" class="mt-n6">
                  <div style="display: flex; align-items: center">
                    <v-menu
                      offset-y
                      width="250"
                      min-height="250"
                      max-height="500"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="50"
                          height="50"
                          class="mt-2 ml-5"
                        >
                          <v-img
                            :src="materialTextures.metallicRoughnessTexture"
                            width="50"
                            height="50"
                            contain
                            ratio="1"
                          ></v-img>
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="250"
                        min-height="250"
                        max-height="500"
                        color="#F5F5F5"
                        class="ma-0 pa-0 expand"
                      >
                        <div
                          class="ma-0 pa-0 mb-n8"
                          style="display: flex; justify-content: end"
                        >
                          <v-btn icon @click="inputFileClick('2')">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <input
                            type="file"
                            id="inputTexture2"
                            style="display: none"
                            @change="changeTexture('2')"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            -webkit-flex-wrap: wrap;
                            flex-wrap: wrap;
                          "
                        >
                          <div
                            class="ml-4 mb-n8"
                            v-for="(item, index) in materialTexturesSelection"
                            :key="index"
                          >
                            <v-card
                              v-on="on"
                              elevation="0"
                              width="50"
                              height="50"
                              v-if="item"
                              @click="
                                applyTextureToModel(
                                  item,
                                  'metallicRoughnessTexture'
                                )
                              "
                            >
                              <v-img
                                :src="item"
                                width="50"
                                height="50"
                                contain
                                ratio="1"
                              ></v-img>
                            </v-card>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Texture
                    </p>
                  </div>
                  <p style="font-size: 10px; font-weight: 500" class="ml-5">
                    Metallic Factor
                  </p>
                  <v-slider
                    class="mt-n5 mr-3 ml-3"
                    thumb-label
                    v-model="metallicFactor"
                    min="0"
                    max="1"
                    step="0.01"
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="ml-5 mt-n6"
                  >
                    Roughness Factor
                  </p>
                  <v-slider
                    class="mt-n5 mb-n6 mr-3 ml-3"
                    thumb-label
                    v-model="roughnessFactor"
                    min="0"
                    max="1"
                    step="0.01"
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Occlusion</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="occlusion = !occlusion"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="occlusion" class="mt-n5">
                  <div style="display: flex; align-items: center" class="mb-4">
                    <v-menu
                      offset-y
                      width="250"
                      min-height="250"
                      max-height="500"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="50"
                          height="50"
                          class="mt-2 ml-5"
                        >
                          <v-img
                            :src="materialTextures.occlusionTexture"
                            width="50"
                            height="50"
                            contain
                            ratio="1"
                          ></v-img>
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="250"
                        min-height="250"
                        max-height="500"
                        color="#F5F5F5"
                        class="ma-0 pa-0 expand"
                      >
                        <div
                          class="ma-0 pa-0 mb-n8"
                          style="display: flex; justify-content: end"
                        >
                          <v-btn icon @click="inputFileClick('3')">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <input
                            type="file"
                            id="inputTexture3"
                            style="display: none"
                            @change="changeTexture('3')"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            -webkit-flex-wrap: wrap;
                            flex-wrap: wrap;
                          "
                        >
                          <div
                            class="ml-4 mb-n8"
                            v-for="(item, index) in materialTexturesSelection"
                            :key="index"
                          >
                            <v-card
                              v-on="on"
                              elevation="0"
                              width="50"
                              height="50"
                              v-if="item"
                              @click="
                                applyTextureToModel(item, 'occlusionTexture')
                              "
                            >
                              <v-img
                                :src="item"
                                width="50"
                                height="50"
                                contain
                                ratio="1"
                              ></v-img>
                            </v-card>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Texture
                    </p>
                  </div>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Normal Map</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      size="22"
                      color="blue"
                      class="ml-n2"
                      @click="normalMap = !normalMap"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>

                <div v-if="normalMap" class="mt-n5">
                  <div style="display: flex; align-items: center" class="mb-4">
                    <v-menu
                      offset-y
                      width="250"
                      min-height="250"
                      max-height="500"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="50"
                          height="50"
                          class="mt-2 ml-5"
                        >
                          <v-img
                            :src="materialTextures.normalTexture"
                            width="50"
                            height="50"
                            contain
                            ratio="1"
                          ></v-img>
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="250"
                        min-height="250"
                        max-height="500"
                        color="#F5F5F5"
                        class="ma-0 pa-0 expand"
                      >
                        <div
                          class="ma-0 pa-0 mb-n8"
                          style="display: flex; justify-content: end"
                        >
                          <v-btn icon @click="inputFileClick('4')">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <input
                            type="file"
                            id="inputTexture4"
                            style="display: none"
                            @change="changeTexture('4')"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            -webkit-flex-wrap: wrap;
                            flex-wrap: wrap;
                          "
                        >
                          <div
                            class="ml-4 mb-n8"
                            v-for="(item, index) in materialTexturesSelection"
                            :key="index"
                          >
                            <v-card
                              v-on="on"
                              elevation="0"
                              width="50"
                              height="50"
                              v-if="item"
                              @click="
                                applyTextureToModel(item, 'normalTexture')
                              "
                            >
                              <v-img
                                :src="item"
                                width="50"
                                height="50"
                                contain
                                ratio="1"
                              ></v-img>
                            </v-card>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Texture
                    </p>
                  </div>
                </div>
                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Emissive Map</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="emissive = !emissive"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="emissive" class="mt-n5">
                  <div style="display: flex; align-items: center">
                    <v-menu
                      offset-y
                      width="250"
                      min-height="250"
                      max-height="500"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="50"
                          height="50"
                          class="mt-2 ml-5"
                        >
                          <v-img
                            :src="materialTextures.emissiveTexture"
                            width="50"
                            height="50"
                            contain
                            ratio="1"
                          ></v-img>
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="250"
                        min-height="250"
                        max-height="500"
                        color="#F5F5F5"
                        class="ma-0 pa-0 expand"
                      >
                        <div
                          class="ma-0 pa-0 mb-n8"
                          style="display: flex; justify-content: end"
                        >
                          <v-btn icon @click="inputFileClick('5')">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <input
                            type="file"
                            id="inputTexture5"
                            style="display: none"
                            @change="changeTexture('5')"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            -webkit-flex-wrap: wrap;
                            flex-wrap: wrap;
                          "
                        >
                          <div
                            class="ml-4 mb-n8"
                            v-for="(item, index) in materialTexturesSelection"
                            :key="index"
                          >
                            <v-card
                              v-on="on"
                              elevation="0"
                              width="50"
                              height="50"
                              v-if="item"
                              @click="
                                applyTextureToModel(item, 'emissiveTexture')
                              "
                            >
                              <v-img
                                :src="item"
                                width="50"
                                height="50"
                                contain
                                ratio="1"
                              ></v-img>
                            </v-card>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Texture
                    </p>
                  </div>
                  <div style="display: flex; align-items: center">
                    <v-menu offset-y min-width="100" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="2"
                          width="50"
                          height="50"
                          :color="emissiveFactor"
                          class="mt-2 ml-5"
                        >
                        </v-card>
                      </template>
                      <v-color-picker
                        mode="rgba"
                        v-model="emissiveFactor"
                      ></v-color-picker>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-2"
                    >
                      Factor
                    </p>
                  </div>
                </div>
              </v-card>

              <!-- <v-autocomplete
                  style="margin-top: 1em"
                  prepend-icon="search"
                  v-model="select"
                  :loading="loading"
                  color="#d3d3d3"
                  item-color="#d3d3d3"
                  :items="hdrFileItems"
                  :item-text="hdrFileItems.filename"
                  return-object
                  :search-input.sync="search"
                  filled
                  rounded
                  dense
                  hide-no-data
                  hide-details
                >
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content
                        v-text="data.item"
                      ></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-avatar>
                        <img :src="data.item.avatar" />
                      </v-list-item-avatar>
                      <v-list-item-content
                        @click="changeHDRfile(data.item.filehdr)"
                      >
                        <v-list-item-title
                          v-html="data.item.filename"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
                <v-row justify="center">
                  <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-flex>
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          style="width: 90%; margin-left: 4%"
                        >
                          <span style="" text
                            ><v-icon>mdi-plus</v-icon>add own HDR</span
                          >
                        </v-btn>
                      </v-flex>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline"> HDR </span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                label="File name*"
                                v-model="hdrFileName"
                                required
                              ></v-text-field>
                            </v-col>

                            <v-file-input
                              cols="12"
                              accept=".hdr"
                              v-model="hdrFile"
                              placeholder="Pick HDR File"
                              label="HDR"
                              required
                            ></v-file-input>
                          </v-row>
                        </v-container>
                        <small>*indicates required field</small>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="dialog = false"
                        >
                          Close
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="submitFile">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-card> -->

              <!-- 6 card -->

              <!-- <v-card
                v-if="spanbtncard"
                width="150"
                elevation="0"
                height="415"
                style="margin-top: 1.2em; margin-left: 0.4em"
              >
                <v-flex
                  v-for="spanbtn in spanbtns"
                  :key="spanbtn"
                  style="margin-top: 15%"
                >
                  <v-btn text style="width: 90%">
                    <span text>{{ spanbtn.name }}</span>
                  </v-btn>
                </v-flex>
              </v-card> -->
              <!-- 7 card -->

              <!-- 6 card -->
              <v-card
                v-if="filebtncard"
                width="170"
                elevation="0"
                height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <div v-for="(item, index) in filebtns" :key="index">
                  <v-row
                    class="ml-1 mb-3"
                    v-if="item.name === 'Original File' && item.checked"
                    style="
                      background-color: #b3e5fc;
                      height: 2.5em;
                      border-radius: 10px;
                      opacity: 0.8;
                    "
                    @click="selectviewerfile(index)"
                  >
                    <v-col cols="9">
                      <p
                        class="caption-11 mt-n1 pl-n3"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>
                  <v-row
                    class="ml-1 mb-3"
                    v-if="item.name === 'Original File' && !item.checked"
                    @click="selectviewerfile(index)"
                    style="height: 2.5em"
                  >
                    <v-col cols="9">
                      <p
                        class="caption-11 mt-n1"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>
                  <v-row
                    class="ml-1 mt-n1 mb-2"
                    style="
                      background-color: #b3e5fc;
                      height: 2.5em;
                      border-radius: 10px;
                      opacity: 0.8;
                    "
                    v-if="item.checked && item.name !== 'Original File'"
                    @click="selectviewerfile(index)"
                  >
                    <div style="display: flex" class="pl-2 mt-n1">
                      <md-icon
                        v-if="augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg1"
                      />
                      <md-icon
                        v-if="!augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg2"
                      />
                      <p
                        class="caption-11 mt-3 ml-2"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </div>
                  </v-row>
                  <v-row
                    class="ml-1 mt-n1 mb-2"
                    v-if="!item.checked && item.name !== 'Original File'"
                    @click="selectviewerfile(index)"
                  >
                    <div style="display: flex" class="pl-2 mt-n1">
                      <md-icon
                        v-if="augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg1"
                      />
                      <md-icon
                        v-if="!augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg2"
                      />
                      <p
                        class="caption-11 mt-3 ml-2"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </div>
                  </v-row>
                </div>
                <!-- <v-flex class="pt-2 pb-5">
                  <v-btn text style="width: 90%">
                    <p
                      class="caption-11 pt-2"
                      style="font-weight: 700; opacity: 0.8"
                    >
                      Original File
                    </p>
                  </v-btn>
                </v-flex> -->
                <!-- <v-row v-for="(item, index) in filebtns" :key="index">
                  <v-row v-if="item.name === 'Original File'">
                    <v-col cols="2"> </v-col>
                    <v-col cols="8">
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="2"> </v-col>
                  </v-row>
                  <v-row
                    v-if="item.name !== 'Original File'"
                    @click="checkExportFiles(item, index)"
                    class="mt-n8"
                  >
                    <v-col cols="1" class="ml-5">
                      <md-icon
                        v-if="augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg1"
                      />
                      <md-icon
                        v-if="!augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg2"
                      />
                    </v-col>
                    <v-col cols="6">
                      <p
                        class="caption-11 mt-1 ml-2"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="1">
                      <v-checkbox class="mt-n1"></v-checkbox>
                    </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>
                </v-row> -->
              </v-card>
              <!-- 7th card -->
              <v-card
                v-if="photobtncard"
                width="170"
                elevation="0"
                min-height="340"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <v-row class="">
                  <v-col cols="8">
                    <p class="ml-1 mt-n1 caption-11">Resize Textures</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      class="mt-n2 ml-n2"
                      size="22"
                      color="primary"
                      @click="photomaterialtexture = !photomaterialtexture"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                  <v-col cols="1">
                    <v-checkbox class="mt-n2"></v-checkbox>
                  </v-col>
                  <v-col cols="1"> </v-col>
                </v-row>

                <div
                  v-if="photomaterialtexture"
                  class="ma-0 pa-0 mt-n14 ml-1 mb-8"
                >
                  <p style="font-size: 10px; font-weight: 450" class="ml-2">
                    Texture Format
                  </p>
                  <v-select
                    rounded
                    outlined
                    dense
                    label="Same as Sourse"
                    class="mt-n3"
                    :item="textureitem"
                  >
                  </v-select>
                  <!-- <div
                    style="
                      display: flex;
                      height: 2.5em;
                      border-radius: 14px;
                      background-color: #e0e0e0;
                      opacity: 0.9;
                    "
                    class="mt-n4"
                  >
                    <p class="ml-2 mt-2" style="font-weight: 400">
                      Same as Sourse
                    </p>
                    <v-icon size="22" color="primary" class="mt-n1 ml-6"
                      >mdi-menu-down</v-icon
                    >
                  </div> -->
                </div>
                <p class="caption-11 mt-n14 ml-1">Compression quality</p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="Compressionquality"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n2"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedCompressionquality }}
                    <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                  </p>
                </div>
                <p class="caption-11 mt-n6 ml-1">Downsizing amount</p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="Downsizingamount"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n2"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedDownsizingamount }}
                    <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                  </p>
                </div>
                <v-card
                  elevation="0"
                  width="175"
                  height="250"
                  color="#e0e0e0"
                  rounded="xl"
                  class="mt-n4"
                >
                  <div style="display: flex" class="pt-4 pl-4 pr-4">
                    <p style="font-size: 11px; font-weight: 570">
                      Texture Info
                    </p>
                    <v-spacer></v-spacer>
                    <v-icon size="24" class="mt-n2" color="black"
                      >mdi-information-outline</v-icon
                    >
                  </div>
                  <div style="display: flex" class="pl-7 pr-4">
                    <p class="caption-11">Format</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">PNG</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n1">
                    <p class="caption-11">Original</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">4096 px</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n1">
                    <p class="caption-11">Resized to</p>
                    <v-spacer></v-spacer>
                    <p style="color: #419cff" class="caption-11">1434 px</p>
                  </div>
                  <v-banner
                    color="#00897B"
                    height="1"
                    dark
                    width="175"
                    style="opacity: 0.4"
                  ></v-banner>
                  <div style="display: flex" class="pl-4 pr-4 pt-2">
                    <p style="font-size: 11px; font-weight: 570">File Size</p>
                    <v-spacer></v-spacer>
                    <p style="font-size: 11px; font-weight: 570">improved</p>
                    <p
                      style="font-size: 11px; font-weight: 570; color: #419cff"
                    >
                      :33.33%
                    </p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4">
                    <p class="caption-11">Before:</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">12 mb</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n2">
                    <p class="caption-11">After:</p>
                    <v-spacer></v-spacer>
                    <p style="color: #419cff" class="caption-11">8 mb</p>
                  </div>
                </v-card>
                <div
                  class="ml-2 mb-3"
                  style="
                    height: 1.6em;
                    border-radius: 23px;
                    background-color: #419cff;
                    cursor: pointer;
                  "
                >
                  <p style="text-align: center; color: white">Apply</p>
                </div>
              </v-card>
              <!-- 8th card -->
              <v-card
                v-if="camerabtncard"
                width="170"
                elevation="0"
                min-height="340"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <!-- Camera Viewer settings -->
                <div class="ma-0 pa-0 mt-6">
                  <p class="ml-1 caption-11">
                    Viewer Settings<v-icon
                      v-if="!cameraViewerSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraViewerSettings = !cameraViewerSettings"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraViewerSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraViewerSettings = !cameraViewerSettings"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraViewerSettings"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Resume last View</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox class="mt-n1 mr-n3"></v-checkbox>
                  </div>
                </div>
                <!-- Synch DetailPage -->
                <div class="ma-0 pa-0 mt-n1">
                  <p class="ml-1 caption-11">
                    Synch & Share<v-icon
                      v-if="!cameraSyncAndShare"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraSyncAndShare = !cameraSyncAndShare"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraSyncAndShare"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraSyncAndShare = !cameraSyncAndShare"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraSyncAndShare"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Synch Detailpage</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox class="mt-n1 mr-n3"></v-checkbox>
                  </div>
                </div>
                <!-- Trunable Controls -->
                <div class="ma-0 pa-0 mt-n1">
                  <p class="ml-1 caption-11">
                    Turnable Controls<v-icon
                      v-if="!cameraTurnableControls"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraTurnableControls = !cameraTurnableControls"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraTurnableControls"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraTurnableControls = !cameraTurnableControls"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraTurnableControls"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Enable Turnable</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div
                    class="ma-0 pa-0"
                    style="display: flex"
                    v-if="directionClockWise"
                  >
                    <div class="ma-0 pa-0">
                      <v-icon @click="directionClockWise = false">
                        mdi-menu-left
                      </v-icon>
                    </div>
                    <div class="ma-0 pa-0 ml-n1">
                      <v-icon
                        @click="directionClockWise = true"
                        color="primary"
                      >
                        mdi-menu-right
                      </v-icon>
                    </div>
                  </div>
                  <div
                    class="ma-0 pa-0"
                    style="display: flex"
                    v-if="!directionClockWise"
                  >
                    <div class="ma-0 pa-0">
                      <v-icon
                        @click="directionClockWise = false"
                        color="primary"
                      >
                        mdi-menu-left
                      </v-icon>
                    </div>
                    <div class="ma-0 pa-0 ml-n1">
                      <v-icon @click="directionClockWise = true">
                        mdi-menu-right
                      </v-icon>
                    </div>
                  </div>
                  <div class="ma-0 pa-0">
                    <v-checkbox
                      v-model="glbRotation"
                      class="mt-n1 mr-n3"
                    ></v-checkbox>
                  </div>
                </div>
                <div
                  class="ma-0 pa-0 mt-n4 mb-n3 ml-1"
                  v-if="cameraTurnableControls"
                >
                  <p class="mt-n1 mb-n1" style="font-size: 14px">
                    Turnable Speed
                  </p>
                  <v-slider
                    v-model="speedAndDirectionOfModel"
                    min="0"
                    max="100"
                    step="5"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                </div>
                <!-- Camera Limits -->
                <div class="ma-0 pa-0 mt-n1 mb-n3">
                  <p class="ml-1 caption-11">
                    Camera Limits<v-icon
                      v-if="!cameraCameraLimits"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraCameraLimits = !cameraCameraLimits"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraCameraLimits"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraCameraLimits = !cameraCameraLimits"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div class="ma-0 pa-0" v-if="cameraCameraLimits">
                  <div
                    class="ma-0 pa-0"
                    v-for="(item, index) in cameraCameraLimitsOptions"
                    :key="index"
                  >
                    <div style="display: flex" class="ma-0 pa-0 mb-n5">
                      <div class="ma-0 pa-0 ml-1">
                        <p style="font-size: 14px">{{ item.title }}</p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0">
                        <v-checkbox
                          v-model="item.checked"
                          class="mt-n1 mr-n3"
                        ></v-checkbox>
                      </div>
                    </div>
                    <div
                      class="ma-0 pa-0 mt-1"
                      v-if="item.checked && item.title != 'Apply Minimum Zoom'"
                    >
                      <div class="ma-0 pa-0 mb-n4 ml-1">
                        <p class="mt-n1 mb-n1" style="font-size: 14px">
                          {{ item.minLimitTitle }}
                        </p>
                        <v-slider
                          v-model="item.minValue"
                          :min="item.minLimit"
                          :max="item.maxLimit"
                          step="5"
                          thumb-label
                          track-color="grey"
                          track-fill-color="grey"
                        >
                        </v-slider>
                      </div>
                      <div class="ma-0 pa-0 mt-n7 mb-n2 ml-1">
                        <p class="mt-n1 mb-n1" style="font-size: 14px">
                          {{ item.maxLimitTitle }}
                        </p>
                        <v-slider
                          v-model="item.maxValue"
                          :min="item.minLimit"
                          :max="item.maxLimit"
                          step="5"
                          thumb-label
                          track-color="grey"
                          track-fill-color="grey"
                        >
                        </v-slider>
                      </div>
                    </div>
                    <div
                      v-if="item.checked && item.title == 'Apply Minimum Zoom'"
                      class="ma-0 pa-0 mt-2"
                      style="display: flex"
                    >
                      <v-btn
                        small
                        height="25"
                        width="72"
                        rounded
                        color="primary"
                        class="ma-0"
                        style="text-transform: none"
                        >Set Min</v-btn
                      >

                      <v-btn
                        small
                        height="25"
                        width="92"
                        rounded
                        color="primary"
                        class="ma-0 ml-2"
                        style="text-transform: none"
                        >Reset Min</v-btn
                      >
                    </div>
                  </div>
                  <!-- due to avoid layout overlay -->
                  <div class="ma-0 pa-0 mb-5"></div>
                </div>
                <!-- <div
                  v-if="cameraCameraLimits"
                  class="ma-0 pa-0 mt-2 mb-4"
                  style="display: flex"
                >
                  <v-btn
                    small
                    height="25"
                    width="72"
                    rounded
                    color="primary"
                    class="ma-0"
                    style="text-transform: none"
                    >Set Min</v-btn
                  >

                  <v-btn
                    small
                    height="25"
                    width="92"
                    rounded
                    color="primary"
                    class="ma-0 ml-2"
                    style="text-transform: none"
                    >Reset Min</v-btn
                  >
                </div> -->
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </div>
    <!-- end viewer settings component -->

    <div
      id="changeCardPopUp"
      style="display: none; position: absolute; top: 0px; left: 30px"
    >
      <hotspotcard
        :goToTheChangeCard="() => fg(changeCardSlug)"
        :deleteThisTask="() => deleteTheTaskAnnotation(changeCardID)"
        :title="changeCardTitle"
        :description="changeCardDescription"
        :idComp="changeCardID"
        :slug="changeCardSlug"
      ></hotspotcard>
    </div>

    <div
      class="annotationpopupBack"
      @click.self.prevent="whichTextureModel = !whichTextureModel"
      v-if="whichTextureModel"
    >
      <span class="close" @click="whichTextureModel = !whichTextureModel"
        >&times;</span
      >
      <v-card
        width="300"
        min-height="300"
        class="annotationpop mt-n10 ma-0 pa-0"
        rounded="xl"
        :style="{ background: $vuetify.theme.themes[theme].background }"
      >
        <div class="pl-7 pr-7 pt-4 ma-0">
          <p class="display-22 text-center">
            <strong>Texture Mapping</strong>
          </p>

          <p class="text-center mt-n2" style="font-size: 12px">
            Where do you want to apply texture?
          </p>
          <v-divider
            class="pl-5 pr-5 mt-n3"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- <div v-for="(item,key) in materialTextures" :key="key">
          <div class="ma-0 pa-0" style="display: flex">
            <div class="ma-0 pa-0"> -->
          <v-radio-group v-model="whichTextureModelValue">
            <v-radio
              v-for="(item, key) in materialTextures"
              :key="key"
              :value="key"
              :label="key"
            >
              <!-- <template v-slot:label>
                <div class="ma-0 pa-0">
                  <p>{{ key }}</p>
                </div>
              </template> -->
            </v-radio>
          </v-radio-group>
          <v-divider
            class="pl-5 pr-5 mt-n3"
            style="border-color: #d3d3d3"
          ></v-divider>
          <v-btn
            text
            class="mt-1"
            :style="{ left: '50%', transform: 'translateX(-50%)' }"
            @click="
              applyTextureToModel(whichTextureModelData, whichTextureModelValue)
            "
            >Apply</v-btn
          >
        </div>
      </v-card>
    </div>

    <RouterView />

    <v-overlay :value="overlayP">
      <v-progress-circular v-bind="spinnerProps"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import colorPicker from "@caohenghu/vue-colorpicker";

import { showAt, hideAt } from "vue-breakpoints";

import notificationbar from "./notificationbar";
//import annotationCard from "./annotationCard";

import changecard from "@/components/changecard";

import hotspotcard from "@/components/hotspotCard";

//import { Mesh, MeshStandardMaterial } from "three/build/three.module.js";

//import hdrSettingsC from "./hdrsettings";
//import detailedUIofCard from "./detailedUIofCard";
import CMS from "./CMS";

import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer.js";

//import {GltfModel, Material as GltfMaterial, TextureHandle} from '@google/model-viewer-editing-adapter/lib/main.js'
//import {RGB, RGBA} from '@google/model-viewer/lib/model-viewer';

//import { GltfModel as GltfMaterial } from "@google/model-viewer-editing-adapter/lib/main.js";

import store from "../store";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "viewer",
  components: {
    hideAt,
    showAt,
    colorPicker,
    notificationbar,
    hotspotcard,

    //detailedUIofCard,

    //annotationCard,
    changecard,
    CMS,
    //hdrSettingsC,
  },

  props: ["bus"],

  data: function () {
    return {
      overlayP: false,
      spinnerProps: {
        color: "primary",
        value: 100,
        indeterminate: true,
        size: 80,
      },
      whichTextureModel: false,
      whichTextureModelValue: "",
      whichTextureModelData: "",
      materialTextures: {
        baseColorTexture: "",
        metallicRoughnessTexture: "",
        normalTexture: "",
        occlusionTexture: "",
        emissiveTexture: "",
      },
      materialTexturesSelection: [],
      fileConfig: "",
      cameraOrbit: "",
      fieldOfView: "",
      tempHotSpot: false,
      Compressionquality: "0.0",
      computedCompressionquality: "0.0",
      Downsizingamount: "0.0",
      computedDownsizingamount: "0.0",
      photomaterialtexture: false,

      //animationAnimationSettings
      animationAnimationSettings: false,
      animationAnimationControls: false,
      animationBlendAnimations: false,
      glbAnimationButton: false,
      animationLoopButton: false,

      //cameraViewerSettings
      cameraViewerSettings: false,
      cameraSyncAndShare: false,
      cameraTurnableControls: false,
      cameraCameraLimits: false,
      cameraCameraLimitsOptions: [
        {
          title: "Apply Yaw Limits",
          checked: false,
          minLimitTitle: "Counter-Clockwise Limit",
          minLimit: "-180",
          minValue: "-180",
          maxLimitTitle: "Clockwise Limit",
          maxLimit: "180",
          maxValue: "180",
          default: "auto",
        },
        {
          title: "Apply Pitch Limits",
          checked: false,
          minLimitTitle: "Top-down Limit",
          minLimit: "0",
          minValue: "0",
          maxLimitTitle: "Bottom-up Limit",
          maxLimit: "180",
          maxValue: "180",
          default: "auto",
        },
        {
          title: "Apply Minimum Zoom",
          checked: false,
          minLimitTitle: "Top-down Limit",
          minLimit: "0",
          maxLimitTitle: "Bottom-up Limit",
          maxLimit: "180",
          default: "auto",
        },
      ],

      changeCardTitle: "",
      changeCardDescription: "",
      changeCardID: 0,
      changeCardSlug: "",
      changeDotClick: false,
      username: "",
      isActive: false,
      isAnnotation: false,
      annotationTitle: "",
      isCard: false, //added for zubiUI
      isDetailUI: false,
      isCMS: false,
      form: false,
      extention: "",
      notify: false,
      fileName: "",
      version: "",
      file: "",
      fileNameValue: false,
      hotspotCounter: 0,
      selectedHotspot: HTMLElement,
      positionAndNormal1: "",
      simpleNotificationPosition: false,
      annotationNotificationPosition: false,
      simplePositionDiv: false,
      annotationPositionDiv: false,
      isNotify: true, //this one
      isDetailCard: false,
      transparency: false,
      metalness: false,
      baseColor: false,
      occlusion: false,
      normalMap: false,
      emissive: false,
      hdrlist: false,
      downloaddropdown1: true,
      localitems: [
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
        { list: "chines_garden_4k.hdr" },
      ],
      items: [],
      textureitem: ["Same as Sourse", "JPEG"],

      downloadMenu: false,

      cmsMenu: false,
      cmsType: [{ title: "Full CMS" }, { title: "Basic CMS" }],

      hotspotItems: [],

      type: "hex",
      hex: "#FF0000",
      presentHotSpotColors: [],
      typeMC: "rgba",
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      callFunction: false,
      locationGLB: "",
      fileID: "",
      filePNG: "",
      fileusdz: "",

      hdrFileItems: [],
      hdrItem: "",
      hdrSelectItems: [],

      hdritems: [
        {
          icon: "mdi-box-shadow",
          title: "shadowIntensity",
          value: "",
          max: "10",
        },
        {
          icon: "mdi-blender-software",
          title: "shadowSoftness",
          value: "",
          max: "1",
        },
        {
          icon: "mdi-lightbulb-on-outline",
          title: "exposure",
          value: "",
          max: "2",
        },
      ],
      hdrSettings: false,
      glbRotation: false,
      glbAnimation: false,

      fullscreen: false,

      opacity: 0.46,
      overlay: false,
      zIndex: 5,

      //start viewer settings data

      lightbutton: true,
      mediabutton: false,
      circlebutton: false,
      spanbtncard: false,
      boxbtncard: false,
      colorbtncard: false,
      filebtncard: false,
      photobtncard: false,
      camerabtncard: false,
      spanbtns: [
        { name: "Normals" },
        { name: "Albedo" },
        { name: "Reflectivity" },
        { name: "Gloss" },
        { name: "Typography" },
        { name: "Textured" },
      ],

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
        { color: "orange" },
        { color: "grey" },
      ],
      filebtns: [
        {
          name: "Original File",
          checked: false,
        },
        {
          name: "GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLTF",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
          // svg1: "/static/assets/svg/white/dracoIcon.svg",
          // svg2: "/static/assets/svg/black/dracoIcon.svg",
        },

        // {
        //   name: "Draco",
        //   checked: true,
        //   svg1: "/static/assets/svg/white/GLBIcon.svg",
        //   svg2: "/static/assets/svg/black/GLBIcon.svg",
        // },
        {
          name: "USD",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      downloadFileItems: [
        {
          title: "Original File",
          value: "original",
          valueMax: "",
          max: "2048",
          size: "",
          checked: true,
          list: true,
        },
        {
          title: "Optimized File",
          value: "draco",
          color: "orange",
          checked: false,
          list: true,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          title: "GLTF File",
          value: "gltf",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },

        {
          title: "USD File",
          value: "usd",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          title: "USDZ File",
          value: "usdz",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      originalGLBfile: false,
      downloadOriginalFile: false,
      downloadGLB: false,
      downloadGLTF: false,
      downloadUSDZ: false,
      sizeDownloadGLB: "",
      sizeDownloadGLTF: "",

      // filebtns: [
      //   { name: "GLB" },
      //   { name: "Draco" },
      //   { name: "USD" },
      //   { name: "USDZ" },
      // ],

      hdrFile: "",
      hdrFileName: "",
      dialog: "",

      //end viewer settings data

      //viewer settings

      //rotation speed and direction
      speedAndDirectionOfModel: "20",
      skipWatchOfSD: false,
      directionClockWise: true,
      speedDirection: "",

      //rotation speed and direction

      //animation
      animationLoop: false,
      animationList: [],
      selectedAnimationList: [],
      playSelectedAnimationList: [],
      animationInterval: "",
      animationSelect: "",
      animationCombined: false,
      animationSelect2nd: "",
      //animation

      //materials
      modelMaterials: [],
      currentMaterial: [],
      roughnessFactor: "",
      metallicFactor: "",
      baseColorFactor: "rgba(255,255,255,1)",
      emissiveFactor: "",
      //materials
      suckerCanvas: null,
      suckerArea: [],
      firstMaterialHighlight: false,

      //shadow settings
      shadowIntensity: "0.0",
      shadowSoftness: "0.0",
      computedShadowIntensity: "0.0",
      computedShadowSoftness: "0.0",
      //shadow settings

      //HDR settings
      hdrExposure: "1",
      asSkybox: false,
      neutralLight: true,
      //HDR setttings

      //viewer settings

      userInfo: {},
      fileDetail: "",
    };
  },

  computed: {
    selectColor: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
    showColor() {
      return this.selectColor;
    },

    selectColorMC: {
      get() {
        return this[this.typeMC];
      },
      set(v) {
        this[this.typeMC] = v;
      },
    },
    showColorMC() {
      return JSON.stringify(
        Object.keys(this.selectColorMC).reduce((selectColorMC, key) => {
          selectColorMC[key] = Number(this.selectColorMC[key].toFixed(2));
          return selectColorMC;
        }, {}),
        null,
        2
      );
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    computedDownloadFileItems() {
      var result = this.downloadFileItems.filter((item) => item.list === true);

      return result;
    },
    animationList2nd() {
      var result = this.animationList.filter(
        (item) => item !== this.animationSelect
      );
      return result;
    },
    computedSelectedAnimationList() {
      var result = this.animationList.filter(
        (item) => !this.selectedAnimationList.includes(item)
      );
      return result;
    },

    //cameraViewerSettings
    applyCameraOrbitsAndFieldOfView: function () {
      return (
        this.cameraCameraLimitsOptions[0].checked,
        this.cameraCameraLimitsOptions[0].minValue,
        this.cameraCameraLimitsOptions[0].maxValue,
        this.cameraCameraLimitsOptions[1].checked,
        this.cameraCameraLimitsOptions[1].minValue,
        this.cameraCameraLimitsOptions[1].maxValue,
        this.cameraCameraLimitsOptions[2].checked,
        this.cameraCameraLimitsOptions[2].minValue,
        this.cameraCameraLimitsOptions[2].maxValue,
        new Date()
      );
    },
    //cameraViewerSettings
  },

  watch: {
    //cameraViewerSettings
    applyCameraOrbitsAndFieldOfView: function () {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      //viewer.setAttribute("");
      if (viewer) {
        var minCameraOrbit;
        var maxCameraOrbit;

        var minYawValue;
        var minPitchValue;
        var minZoomValue;
        var minFieldOfView;
        var maxYawValue;
        var maxPitchValue;
        var maxZoomValue;
        var maxFieldOfView;

        if (this.cameraCameraLimitsOptions[0].checked) {
          minYawValue = this.cameraCameraLimitsOptions[0].minValue + "deg ";
          maxYawValue = this.cameraCameraLimitsOptions[0].maxValue + "deg ";
        } else {
          minYawValue = "auto ";
          maxYawValue = "auto ";
        }
        if (this.cameraCameraLimitsOptions[1].checked) {
          minPitchValue = this.cameraCameraLimitsOptions[1].minValue + "deg ";
          maxPitchValue = this.cameraCameraLimitsOptions[1].maxValue + "deg ";
        } else {
          minPitchValue = "auto ";
          maxPitchValue = "auto ";
        }

        var currentCamera = this.getCameraState(viewer);
        var currFieldOfView = Math.round(currentCamera.fieldOfViewDeg) + "deg";
        var currRadius = currentCamera.orbit?.radius.toFixed(4) + "m";

        if (this.cameraCameraLimitsOptions[2].checked) {
          // minZoomValue = this.cameraCameraLimitsOptions[2].minValue +"m";
          // maxZoomValue = this.cameraCameraLimitsOptions[2].maxValue +"m";

          minZoomValue = currRadius;
          maxZoomValue = currRadius;
          minFieldOfView = currFieldOfView;
          maxFieldOfView = "auto";
        } else {
          minZoomValue = "auto";
          maxZoomValue = "auto";
          minFieldOfView = "auto";
          maxFieldOfView = "auto";
        }

        minCameraOrbit = minYawValue + minPitchValue + minZoomValue;
        maxCameraOrbit = maxYawValue + maxPitchValue + maxZoomValue;
        viewer.setAttribute("min-camera-orbit", minCameraOrbit);
        viewer.setAttribute("max-camera-orbit", maxCameraOrbit);

        viewer.setAttribute("min-field-of-view", minFieldOfView);
        viewer.setAttribute("min-field-of-view", maxFieldOfView);
      }
    },
    applyPitchLimits: function () {},
    //cameraViewerSettings

    currentMaterial: function (val) {
      this.clearMaterialData();
      this.configureCurrentMaterial(val);

      this.materialTextures = {
        metallicRoughnessTexture: "",
        baseColorTexture: "",
        normalTexture: "",
        emissiveTexture: "",
        occlusionTexture: "",
      };

      //hkhkjh
      if (val.pbrMetallicRoughness) {
        if (val.pbrMetallicRoughness.baseColorTexture) {
          let source = val.pbrMetallicRoughness.baseColorTexture.texture.source;
          let sym = Object.getOwnPropertySymbols(source).find(function (s) {
            return String(s) === "Symbol(correlatedObjects)";
          });
          let ii = source[sym].entries().next().value[0].image;
          const dataUrl = this.getDataUrl(ii);
          this.materialTextures.baseColorTexture = dataUrl;
        }
        if (val.pbrMetallicRoughness.metallicRoughnessTexture) {
          let source =
            val.pbrMetallicRoughness.metallicRoughnessTexture.texture.source;
          let sym = Object.getOwnPropertySymbols(source).find(function (s) {
            return String(s) === "Symbol(correlatedObjects)";
          });
          let ii = source[sym].entries().next().value[0].image;
          const dataUrl = this.getDataUrl(ii);
          this.materialTextures.metallicRoughnessTexture = dataUrl;
        }
      }

      if (val.normalTexture) {
        let source = val.normalTexture.texture.source;
        let sym = Object.getOwnPropertySymbols(source).find(function (s) {
          return String(s) === "Symbol(correlatedObjects)";
        });

        let ii = source[sym].entries().next().value[0].image;

        const dataUrl = this.getDataUrl(ii);
        this.materialTextures.normalTexture = dataUrl;
      }
      if (val.occlusionTexture) {
        let source = val.occlusionTexture.texture.source;
        let sym = Object.getOwnPropertySymbols(source).find(function (s) {
          return String(s) === "Symbol(correlatedObjects)";
        });
        let ii = source[sym].entries().next().value[0].image;
        const dataUrl = this.getDataUrl(ii);
        this.materialTextures.occlusionTexture = dataUrl;
      }
      if (val.emissiveTexture) {
        let source = val.emissiveTexture.texture.source;
        let sym = Object.getOwnPropertySymbols(source).find(function (s) {
          return String(s) === "Symbol(correlatedObjects)";
        });
        let ii = source[sym].entries().next().value[0].image;
        const dataUrl = this.getDataUrl(ii);
        this.materialTextures.emissiveTexture = dataUrl;
      }

      if (this.firstMaterialHighlight) {
        this.materialHighlight(val);
      }

      this.firstMaterialHighlight = true;
    },
    metallicFactor: function (val) {
      if (this.currentMaterial.pbrMetallicRoughness) {
        this.currentMaterial.pbrMetallicRoughness.setMetallicFactor(val);
      }
    },
    roughnessFactor: function (val) {
      if (this.currentMaterial.pbrMetallicRoughness) {
        this.currentMaterial.pbrMetallicRoughness.setRoughnessFactor(val);
      }
    },
    baseColorFactor: function (val) {
      let color = this.rgbaStringToArray(val);
      let rgba = [color[0] / 255, color[1] / 255, color[2] / 255, color[3]];
      // let val1 = this.HexToRGB(val);
      // if (this.currentMaterial.pbrMetallicRoughness) {
      //   this.currentMaterial.pbrMetallicRoughness.setBaseColorFactor(val1);
      // }

      // let val1 = [r / 255, g / 255, b / 255, a];
      // // let val1 = this.HexToRGB(val);
      if (this.currentMaterial.pbrMetallicRoughness) {
        this.currentMaterial.pbrMetallicRoughness.setBaseColorFactor(rgba);
      }
    },
    emissiveFactor: function (val) {
      let val1 = this.HexToRGB(val);
      val1.pop();
      if (this.currentMaterial.emissiveTexture) {
        this.currentMaterial.setEmissiveFactor(val1);
      }
    },
    directionClockWise: function (val) {
      if (val === true) {
        this.speedDirection = "";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      } else {
        this.speedDirection = "-";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      }
    },
    speedAndDirectionOfModel: function (val) {
      if (this.skipWatchOfSD === false) {
        this.skipWatchOfSD = true;
        return;
      }
      if (this.glbRotation === false) {
        this.glbRotation = true;
      }

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        viewer["rotationPerSecond"] = this.speedDirection + val + "deg";
      }
    },
    glbRotation: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        if (val === true) {
          //viewer["rotationPerSecond"] = this.speedAndDirectionOfModel + "deg";
          viewer["autoRotateDelay"] = 200;
          viewer["autoRotate"] = true;
        } else {
          viewer["autoRotate"] = false;
        }
      }
    },

    glbAnimation: function (val) {
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      if (this.animationCombined === false) {
        modelViewer["animationName"] = this.animationSelect;
        if (val === true && !this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;
            this.playSelectedAnimations(
              modelViewer,
              this.selectedAnimationList.slice(0),
              false
            );
          } else {
            modelViewer.play();
            this.glbAnimationButton = true;
            setTimeout(
              async function () {
                this.glbAnimation = false;
              }.bind(this),
              modelViewer.duration * 1000
            );
          }
        } else if (val === true && this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;
            this.playSelectedAnimations(
              modelViewer,
              this.selectedAnimationList.slice(0),
              true
            );
          } else {
            modelViewer.play();
            this.glbAnimationButton = true;
          }
        } else if (val === false) {
          modelViewer.pause();
          this.glbAnimationButton = false;
        }
      } else {
        if (val === true) {
          this.glbAnimationButton = true;
          modelViewer.play();
          const interval2 = setInterval(
            async function () {
              modelViewer.animationName =
                modelViewer.animationName === this.animationSelect
                  ? this.animationSelect2nd
                  : this.animationSelect;

              if (this.animationCombined === false) {
                this.glbAnimationButton = false;
                modelViewer.pause();
                clearInterval(interval2);
              }
            }.bind(this),
            modelViewer.duration * 1000
          );
        }
      }
    },
    animationLoop: async function (val) {
      if (val === true) {
        this.animationLoopButton = true;
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      } else {
        this.animationLoopButton = false;
        this.glbAnimation = !this.glbAnimation;
        await this.sleep(1);
        this.glbAnimation = !this.glbAnimation;
      }
    },

    asSkybox: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        if (val === true) {
          viewer.setAttribute("skybox-image", this.hdrItem);
        } else {
          viewer.removeAttribute("skybox-image");
        }
      }
    },
    neutralLight: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        if (val === true) {
          viewer.setAttribute("environment-image", "neutral");
        } else {
          viewer.setAttribute("environment-image", "");
        }
      }
    },

    hdrExposure: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      viewer["exposure"] = parseFloat(val);
    },
    shadowIntensity: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      viewer["shadowIntensity"] = parseFloat(val);
      this.computedShadowIntensity = val.toFixed(1);
    },
    shadowSoftness: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      viewer["shadowSoftness"] = parseFloat(val);
      this.computedShadowSoftness = val.toFixed(1);
    },
  },

  beforeDestroy() {
    //added due to many events
    this.bus.$off("location1", this.location);
  },
  created() {
    //
    this.bus.$on("location1", this.location);
    //

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },

  mounted() {
    this.fileDetail = store.state.fileDetail;
    if (this.fileDetail === "") {
      console.log("e");
    } else {
      this.location(this.fileDetail.fileglb, this.fileDetail.id);
    }

    document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
      const dropZoneElement = inputElement.closest(".drop-zone");
      dropZoneElement.addEventListener("dragover", (e) => {
        e.preventDefault();
        //dropZoneElement.classList.add("drop-zone--over");
      });
      ["dragleave", "dragend"].forEach((type) => {
        dropZoneElement.addEventListener(type, (e) => {
          console.log(e);
          //dropZoneElement.classList.remove("drop-zone--over");
        });
      });
      dropZoneElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
          inputElement.files = e.dataTransfer.files;
          this.updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
        }

        //dropZoneElement.classList.remove("drop-zone--over");
      });
    });

    //
    //this.bus.$on("location1", this.location);

    //HDR files
    axios
      .get(this.$abServerPath + "/api/hdrfiles/hdrgetallfile/", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Token " + this.getAuthCookie("augmentableUserToken") + "",
        },
      }) //for local "/hdrfile/"
      .then((response) => {
        var i;
        var len;

        var obj = {
          file_hdr: "",
          file_name: "",
          id: "",
        };

        for (i = 0, len = response.data.length; i < len; i++) {
          obj = response.data[i];

          obj.file_hdr = this.$abServerPath + "" + response.data[i].file_hdr;
          obj.file_name = "" + response.data[i].file_name;
          obj.id = response.data[i].id;

          //this.hdrSelectItems.push(response.data[i].file_name);
          this.hdrFileItems.push(obj);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //hdr Files

    if (store.state.augmentableTheme) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    if (this.isActive === false) {
      this.$vuetify.theme.dark = false;
    } else if (this.isActive === true) {
      this.$vuetify.theme.dark = true;
    }

    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    //userInfo

    axios
      .get("/dj-rest-auth/user/", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Token " + this.getAuthCookie("augmentableUserToken") + "",
        },
      })
      .then((response) => {
        this.userInfo.id = response.data.pk;
        this.userInfo.username = response.data.username;
        this.userInfo.email = response.data.email;
        this.userInfo.first_name = response.data.first_name;
        this.userInfo.last_name = response.data.last_name;
      })
      .catch((response) => {
        console.log(response);
      });
    //userInfo

    // window.addEventListener("load", function () {
    //   // Experimental: Don't do this at home

    //   const FAKE_JSON =
    //     '{"asset":{"version":"2.0"},"scenes":[{"name":"Scene"}],"scene":0}';
    //   const FAKE_SCENE = URL.createObjectURL(
    //     new Blob([FAKE_JSON], { type: "application/json" })
    //   );

    //   const DEFAULT_MATERAL = new MeshStandardMaterial({
    //     color: 0x606060,
    //     roughness: 1.0,
    //     metalness: 0.0,
    //   });

    //   //added by me
    //   let viewer = new ModelViewerElement();
    //   viewer = document.getElementById("loading-demo");
    //   //added by me

    //   // console.log( Object.getOwnPropertySymbols( viewer ) );

    //   const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];

    //   function setCustomObject(object) {
    //     viewer.src = FAKE_SCENE;
    //     scene.setObject(object);
    //   }

    //   function handleFile(file) {
    //     const extension = file.name.split(".").pop().toLowerCase();
    //     const reader = new FileReader();

    //     switch (extension) {
    //       case "drc":
    //         reader.addEventListener(
    //           "load",
    //           async function (event) {
    //             const { DRACOLoader } = await import(
    //               "./loaders/DRACOLoader.js"
    //             );

    //             const loader = new DRACOLoader();
    //             loader.setDecoderPath("./libs/");
    //             loader.setDecoderConfig({ type: "js" });
    //             loader.decodeDracoFile(
    //               event.target.result,
    //               function (geometry) {
    //                 geometry.computeVertexNormals();

    //                 setCustomObject(new Mesh(geometry, DEFAULT_MATERAL));
    //               }
    //             );
    //           },
    //           false
    //         );
    //         reader.readAsArrayBuffer(file);

    //         break;

    //       case "fbx":
    //         reader.addEventListener(
    //           "load",
    //           async function (event) {
    //             const { FBXLoader } = await import("./loaders/FBXLoader.js");

    //             const object = new FBXLoader().parse(event.target.result);

    //             object.traverse(function (child) {
    //               const material = child.material;

    //               if (material && material.isMeshPhongMaterial) {
    //                 child.material = DEFAULT_MATERAL;
    //               }
    //             });

    //             setCustomObject(object);
    //           },
    //           false
    //         );
    //         reader.readAsArrayBuffer(file);

    //         break;

    //       case "glb":
    //       case "gltf":
    //         viewer.src = URL.createObjectURL(file);

    //         break;

    //       case "obj":
    //         reader.addEventListener(
    //           "load",
    //           async function (event) {
    //             const { OBJLoader } = await import("./loaders/OBJLoader.js");

    //             const object = new OBJLoader().parse(event.target.result);

    //             object.traverse(function (child) {
    //               const material = child.material;

    //               if (material && material.isMeshPhongMaterial) {
    //                 child.material = DEFAULT_MATERAL;
    //               }
    //             });

    //             setCustomObject(object);
    //           },
    //           false
    //         );
    //         reader.readAsText(file);

    //         break;

    //       case "ply":
    //         reader.addEventListener(
    //           "load",
    //           async function (event) {
    //             const { PLYLoader } = await import("./loaders/PLYLoader.js");

    //             const geometry = new PLYLoader().parse(event.target.result);

    //             geometry.computeVertexNormals();

    //             setCustomObject(new Mesh(geometry, DEFAULT_MATERAL));
    //           },
    //           false
    //         );
    //         reader.readAsArrayBuffer(file);

    //         break;

    //       case "stl":
    //         reader.addEventListener(
    //           "load",
    //           async function (event) {
    //             const { STLLoader } = await import("./loaders/STLLoader.js");

    //             const geometry = new STLLoader().parse(event.target.result);

    //             setCustomObject(new Mesh(geometry, DEFAULT_MATERAL));
    //           },
    //           false
    //         );
    //         reader.readAsBinaryString(file);

    //         break;
    //     }
    //   }

    //   document.addEventListener(
    //     "dragover",
    //     function (event) {
    //       event.preventDefault();
    //       event.dataTransfer.dropEffect = "copy";
    //     },
    //     false
    //   );

    //   document.addEventListener(
    //     "drop",
    //     function (event) {
    //       event.preventDefault();
    //       handleFile(event.dataTransfer.files[0]);
    //     },
    //     false
    //   );

    //   // Chrome OS

    //   if ("launchData" in window && Array.isArray(window.launchData.items)) {
    //     var item = window.launchData.items[0];

    //     item.entry.file(handleFile);
    //   }
    // });
  },

  methods: {
    //AnimationSettings
    // playAnimationOnce(){
    //   let viewer = new ModelViewerElement();
    //   viewer = document.getElementById("loading-demo");
    //   viewer.du
    // },
    selectedAnimationListFunc(item) {
      this.selectedAnimationList.push(item);
    },
    removeSelectedAnimationList(index) {
      this.selectedAnimationList.splice(index, 1);
    },
    playSelectedAnimations(viewer, animationList, loop) {
      if (loop) {
        clearInterval(this.animationInterval);

        viewer["animationName"] = animationList.shift();
        //for loop
        if (this.animationLoop) {
          animationList.push(viewer["animationName"]);
        }
        //for loop
        viewer.play();

        // if(!this.glbAnimation){
        //   animationList
        // }
        if (animationList.length == 0) {
          setTimeout(
            function () {
              viewer.pause();
              this.glbAnimation = false;
              this.glbAnimationButton = false;
            }.bind(this),
            viewer.duration * 1000
          );
          //clearInterval(this.animationInterval);
        } else {
          this.animationInterval = setInterval(
            this.playSelectedAnimations,
            viewer.duration * 1000,
            viewer,
            animationList,
            loop
          );
        }
      } else {
        if (this.animationInterval) {
          clearInterval(this.animationInterval);
        }

        viewer["animationName"] = animationList.shift();
        viewer.play();

        if (animationList.length == 0) {
          setTimeout(
            function () {
              viewer.pause();
              this.glbAnimation = false;
              this.glbAnimationButton = false;
            }.bind(this),
            viewer.duration * 1000
          );
          //clearInterval(this.animationInterval);
        } else {
          this.animationInterval = setInterval(
            this.playSelectedAnimations,
            viewer.duration * 1000,
            viewer,
            animationList,
            loop
          );
        }
      }
    },
    // playSelectedAnimationsInterval(){

    // },
    //AnimationSettings
    //cameraViewerSettings
    getCameraState(viewer) {
      const orbitRad = viewer.getCameraOrbit();
      return {
        orbit: {
          thetaDeg: this.radToDeg(orbitRad.theta),
          phiDeg: this.radToDeg(orbitRad.phi),
          radius: orbitRad.radius,
        },
        target: viewer.getCameraTarget(),
        fieldOfViewDeg: viewer.getFieldOfView(),
      };
    },
    radToDeg(radians) {
      return (radians * 180.0) / Math.PI;
    },
    //cameraViewerSettings
    selectviewerfile(x) {
      var i;
      var len;
      for (i = 0, len = this.filebtns.length; i < len; i++) {
        if (x === i) {
          this.filebtns[i].checked = true;
        } else {
          this.filebtns[i].checked = false;
        }
      }

      for (i = 2, len = this.downloadFileItems.length; i <= len; i++) {
        if (x + 1 === i) {
          this.downloadFileItems[i].list = true;
        } else {
          this.downloadFileItems[i].list = false;
        }
      }
    },
    location1(x, y) {
      console.log(x, y);
    },
    changeTheme() {
      if (this.isActive === true) {
        this.isActive = false;
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
      } else if (this.isActive === false) {
        this.isActive = true;
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
      }

      //this.isActive = !this.isActive;

      /*
      if (this.isActive === true) {
        document.getElementById("Zoom1").style.backgroundImage =
          "radial-gradient(#808080, #262626)";
      } else {
        document.getElementById("Zoom1").style.backgroundImage =
          "radial-gradient(white, #cccccc)";
      }
      */
    },
    async updateThumbnail(dropZoneElement, file) {
      let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

      //first time remove it
      if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
      }

      //added o remove previous model element with all its hotspots
      var modelRemoveElement = document.getElementById("loading-demo");
      if (file.name.split(".").pop() === "glb") {
        if (modelRemoveElement) {
          modelRemoveElement.remove();
          thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
        }
      }

      //fist time there is no thumbnail then create
      if (!thumbnailElement) {
        thumbnailElement = document.createElement("model-viewer");

        //add draco compression
        //ModelViewerElement.dracoDecoderLocation =
        //"http://example.com/location/of/draco/decoder/files/";

        //ModelViewerElement.dracoDecoderLocation =
        // "static/assets/images/Shoe_Test.bin";

        //add draco compression

        thumbnailElement.classList.add("drop-zone__thumb");
        //thumbnailElement.setAttribute("auto-rotate", ""); //added functionality
        thumbnailElement.setAttribute("camera-controls", "");
        thumbnailElement.setAttribute("interaction-prompt", "none");

        thumbnailElement.setAttribute("environment-image", "neutral");
        this.neutralLight = true;

        //needs to be added
        /*
        thumbnailElement.setAttribute("ar", "");
        thumbnailElement.setAttribute(
          "ar-modes",
          "webxr scene-viewer quick-look"
        );
        thumbnailElement.setAttribute("ar-scale", "auto");
        */

        //thumbnailElement.setAttribute("autoplay", ""); //added functionality
        //thumbnailElement.setAttribute("animation-name", "Running");

        /////thumbnailElement.setAttribute("camera-orbit", "0deg 75deg 105%");
        /////thumbnailElement.setAttribute("camera-target", "0m 0m 0m");

        //thumbnailElement.setAttribute("rotation-per-second", "200rad");

        //thumbnailElement.setAttribute("align-model", "center");

        //thumbnailElement.setAttribute("style", "");
        //thumbnailElement.style.transformOrigin = "top left";
        //thumbnailElement.setAttribute("transform-origin", "top left");

        //thumbnailElement.setAttribute("interaction-prompt-threshold", "0");
        //thumbnailElement.setAttribute("auto-rotate-delay", "0");
        //thumbnailElement.setAttribute("shadow-intensity", "1"); //added functionality
        thumbnailElement.setAttribute("id", "loading-demo");

        thumbnailElement.style.width = "100%";
        thumbnailElement.style.height = "100vh";
        thumbnailElement.style.minHeight = "100vh";
        dropZoneElement.appendChild(thumbnailElement);

        /*
        let btn1 = document.createElement("button");
        btn1.classList.add("hotspotBtn");
        btn1.setAttribute("slot", "hotspot-hand");
        btn1.setAttribute("data-position", "0 1.75 0.35");
        btn1.setAttribute("data-normal", "0 0 1");
        btn1.style.backgroundColor = "red";
        thumbnailElement.appendChild(btn1);
        */
      }

      thumbnailElement.dataset.label = file.name;

      this.fileName = file.name;

      this.fileName = this.fileName.replace(/\.[^/.]+$/, "");

      this.version = "VERSION 1.0";

      this.extention = file.name.split(".").pop();

      if (
        this.extention === "png" ||
        this.extention === "jpeg" ||
        this.extention === "jpg"
      ) {
        let modelPresent = new ModelViewerElement();
        modelPresent = document.getElementById("loading-demo");
        if (modelPresent.model) {
          let { textureName, data } = await this.checkWhichTexture(file);
          if (textureName) {
            this.applyTextureToModel(data, textureName);

            this.whichTextureModel = false;
            this.whichTextureModelData = "";
            this.whichTextureModelValue = "";
          } else {
            this.whichTextureModel = true;
            this.whichTextureModelData = data;
          }
        }
      }

      if (this.extention === "glb" || this.extention === "gltf") {
        //file upload to server
        this.file = file;
        this.fileName = file.name;

        let formData = new FormData();
        formData.append("file_glb", this.file);
        formData.append("file_name", file.name);
        formData.append("file_type", this.extention);

        //without server
        //this is very very important for local system , also it will save space on server to load src without being file transfered to server and call it.
        thumbnailElement.src = URL.createObjectURL(file);
        // thumbnailElement.onload = function () {
        //   //animation list
        //   this.animationList = thumbnailElement.availableAnimations;
        //   this.animationSelect = this.animationList[0];
        //   alert(this.animationList);
        //   alert(this.animationSelect);

        //   URL.revokeObjectURL(thumbnailElement.src); // free memory
        // };
        thumbnailElement.addEventListener("load", () => {
          this.firstMaterialHighlight = false;

          this.animationList = thumbnailElement.availableAnimations;
          this.animationSelect = this.animationList[0];
          //const names = thumbnailElement.availableVariants;

          this.currentMaterial = [];
          this.modelMaterials = [];
          this.materialTexturesSelection = [];
          this.clearMaterialData();

          let i;
          let len;
          let materials = thumbnailElement.model.materials;

          for (
            i = 0, len = thumbnailElement.model.materials.length;
            i < len;
            i++
          ) {
            if (materials[i].pbrMetallicRoughness) {
              this.currentMaterial = materials[0];
              this.configureCurrentMaterial(this.currentMaterial);
              this.modelMaterials.push(materials[i]);

              if (materials[i].pbrMetallicRoughness.baseColorTexture) {
                let source =
                  materials[i].pbrMetallicRoughness.baseColorTexture.texture
                    .source;
                let sym = Object.getOwnPropertySymbols(source).find(function (
                  s
                ) {
                  return String(s) === "Symbol(correlatedObjects)";
                });
                let ii = source[sym].entries().next().value[0].image;
                const dataUrl = this.getDataUrl(ii);
                this.materialTexturesSelection.push(dataUrl);
              }
              if (materials[i].pbrMetallicRoughness.metallicRoughnessTexture) {
                let source =
                  materials[i].pbrMetallicRoughness.metallicRoughnessTexture
                    .texture.source;
                let sym = Object.getOwnPropertySymbols(source).find(function (
                  s
                ) {
                  return String(s) === "Symbol(correlatedObjects)";
                });
                let ii = source[sym].entries().next().value[0].image;
                const dataUrl = this.getDataUrl(ii);
                this.materialTexturesSelection.push(dataUrl);
              }
            }

            if (materials[i].normalTexture) {
              let source = materials[i].normalTexture.texture.source;
              let sym = Object.getOwnPropertySymbols(source).find(function (s) {
                return String(s) === "Symbol(correlatedObjects)";
              });

              let ii = source[sym].entries().next().value[0].image;

              const dataUrl = this.getDataUrl(ii);
              this.materialTexturesSelection.push(dataUrl);
            }
            if (materials[i].occlusionTexture) {
              let source = materials[i].occlusionTexture.texture.source;
              let sym = Object.getOwnPropertySymbols(source).find(function (s) {
                return String(s) === "Symbol(correlatedObjects)";
              });
              let ii = source[sym].entries().next().value[0].image;
              const dataUrl = this.getDataUrl(ii);
              this.materialTexturesSelection.push(dataUrl);
            }
            if (materials[i].emissiveTexture) {
              let source = materials[i].emissiveTexture.texture.source;
              let sym = Object.getOwnPropertySymbols(source).find(function (s) {
                return String(s) === "Symbol(correlatedObjects)";
              });
              let ii = source[sym].entries().next().value[0].image;
              const dataUrl = this.getDataUrl(ii);
              this.materialTexturesSelection.push(dataUrl);
            }
          }

          URL.revokeObjectURL(thumbnailElement.src);
        });

        //without server
        /*  
        axios
          .post("/arfile/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            //thumbnailElement.src = "static/images/" + file.name;
            
            //thumbnailElement.src = "static/images/" + file.name;
            thumbnailElement.src = response.data.file_glb;

            
            //thumbnailElement.addEventListener("camera-change", this.Listen);
          })
          .catch(function () {
            
            return;
          });

        */

        thumbnailElement.addEventListener("camera-change", this.Listen);

        this.testMaterials();
      }
      if (this.extention === "hdr") {
        this.file = file;

        let formData = new FormData();
        formData.append("file_hdr", this.file);
        formData.append("file_name", this.file.name.replace(/\.[^/.]+$/, ""));
        formData.append(
          "uploaded_file_name",
          this.file.name.replace(/\.[^/.]+$/, "")
        );
        formData.append("file_type", this.extention);
        var tt = this.file.size;

        formData.append("filesize", tt);

        axios
          .post(this.$abServerPath + "/api/hdrfiles/hdrpostfile/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          })
          .then((response) => {
            if (response.data.error) {
              alert(response.data.error);
              return;
            }
            axios
              .get(this.$abServerPath + "/api/hdrfiles/hdrgetallfile/", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Token " + this.getAuthCookie("augmentableUserToken") + "",
                },
              }) //for local "/hdrfile/"
              .then((response) => {
                this.hdrFileItems = [];
                var i;
                var len;

                var obj = {
                  file_hdr: "",
                  file_name: "",
                  id: "",
                };

                for (i = 0, len = response.data.length; i < len; i++) {
                  obj = response.data[i];

                  obj.file_hdr =
                    this.$abServerPath + "" + response.data[i].file_hdr;
                  obj.file_name = "" + response.data[i].file_name;
                  obj.id = response.data[i].id;

                  this.hdrFileItems.push(obj);
                }
              })
              .catch((error) => {
                console.log(error);
              });

            console.log("SUCCESS!!");

            thumbnailElement.setAttribute(
              "skybox-image",
              response.data.file_hdr
            );
          })

          .catch((error) => {
            axios
              .get(this.$abServerPath + "/api/hdrfiles/hdrgetallfile/", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Token " + this.getAuthCookie("augmentableUserToken") + "",
                },
              }) //for local "/hdrfile/"
              .then((response) => {
                this.hdrFileItems = [];
                var i;
                var len;

                var obj = {
                  file_hdr: "",
                  file_name: "",
                  id: "",
                };

                for (i = 0, len = response.data.length; i < len; i++) {
                  obj = response.data[i];

                  obj.file_hdr =
                    this.$abServerPath + "" + response.data[i].file_hdr;
                  obj.file_name = "" + response.data[i].file_name;
                  obj.id = response.data[i].id;

                  this.hdrFileItems.push(obj);
                }

                thumbnailElement.setAttribute(
                  "skybox-image",
                  response.data[response.data.length - 1].file_hdr
                );
              })
              .catch((error) => {
                console.log(error);
              });

            console.log(error);
          });

        /*
        thumbnailElement.setAttribute(
          "skybox-image",
          "static/assets/images/" + file.name
        );
        */
      }

      if (this.extention === "usdz") {
        thumbnailElement.setAttribute("ios-src", "static/images/" + file.name);
      }

      //show thumbnail image for image file
    },
    updateThumbnail1(dropZoneElement, e, usdz, png) {
      let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
      //console.log(e);
      //first time remove it
      if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
      }

      //added o remove previous model element with all its hotspots
      var modelRemoveElement = document.getElementById("loading-demo");

      if (modelRemoveElement) {
        modelRemoveElement.remove();
        thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
      }

      //fist time there is no thumbnail then create
      if (!thumbnailElement) {
        thumbnailElement = document.createElement("model-viewer");

        //add draco compression

        //ModelViewerElement.dracoDecoderLocation =
        //"http://example.com/location/of/draco/decoder/files/";

        //add draco compression

        thumbnailElement.classList.add("drop-zone__thumb");
        //thumbnailElement.setAttribute("auto-rotate", ""); //added functionality
        thumbnailElement.setAttribute("camera-controls", "");
        thumbnailElement.setAttribute("interaction-prompt", "none");

        thumbnailElement.setAttribute("environment-image", "neutral");
        this.neutralLight = true;

        //needs to be added
        /*
        thumbnailElement.setAttribute("ar", "");
        thumbnailElement.setAttribute(
          "ar-modes",
          "webxr scene-viewer quick-look"
        );
        thumbnailElement.setAttribute("ar-scale", "auto");
        */

        thumbnailElement.setAttribute("camera-orbit", "0deg 75deg 105%");

        //thumbnailElement.setAttribute("rotation-per-second", "600%");

        //thumbnailElement.setAttribute("interaction-prompt-threshold", "0");
        //thumbnailElement.setAttribute("auto-rotate-delay", "0");
        //thumbnailElement.setAttribute("shadow-intensity", "1"); //added functionality
        thumbnailElement.setAttribute("id", "loading-demo");

        thumbnailElement.style.width = "100%";
        thumbnailElement.style.height = "100vh";
        thumbnailElement.style.minHeight = "100vh";
        dropZoneElement.appendChild(thumbnailElement);
      }

      // if (thumbnailElement) {
      //   console.log("Yes Exists");
      // }

      thumbnailElement.src = e;
      //animation list
      thumbnailElement.addEventListener("load", async () => {
        if (this.fileConfig) {
          this.neutralLight = this.fileConfig["neutralLight"];
          this.hdrExposure = this.fileConfig["hdrExposure"];
          this.shadowIntensity = this.fileConfig["shadowIntensity"];
          this.shadowSoftness = this.fileConfig["shadowSoftness"];
        } else {
          this.neutralLight = true;
          this.hdrExposure = "1";
          this.shadowIntensity = "0.0";
          this.shadowSoftness = "0.0";
        }

        this.firstMaterialHighlight = false;

        this.currentMaterial = [];
        this.modelMaterials = [];
        this.materialTexturesSelection = [];
        this.clearMaterialData();

        this.animationList = thumbnailElement.availableAnimations;
        this.animationSelect = this.animationList[0];
        //const names = thumbnailElement.availableVariants;

        let i;
        let len;
        let materials = thumbnailElement.model.materials;

        for (
          i = 0, len = thumbnailElement.model.materials.length;
          i < len;
          i++
        ) {
          if (materials[i].pbrMetallicRoughness) {
            materials[0].id = 1;
            this.currentMaterial = materials[0];
            this.configureCurrentMaterial(this.currentMaterial);
            materials[i].id = i + 1;

            this.modelMaterials.push(materials[i]);

            if (materials[i].pbrMetallicRoughness.baseColorTexture) {
              let source =
                materials[i].pbrMetallicRoughness.baseColorTexture.texture
                  .source;
              let sym = Object.getOwnPropertySymbols(source).find(function (s) {
                return String(s) === "Symbol(correlatedObjects)";
              });
              let ii = source[sym].entries().next().value[0].image;
              const dataUrl = this.getDataUrl(ii);
              this.materialTexturesSelection.push(dataUrl);
            }
            if (materials[i].pbrMetallicRoughness.metallicRoughnessTexture) {
              let source =
                materials[i].pbrMetallicRoughness.metallicRoughnessTexture
                  .texture.source;
              let sym = Object.getOwnPropertySymbols(source).find(function (s) {
                return String(s) === "Symbol(correlatedObjects)";
              });
              let ii = source[sym].entries().next().value[0].image;
              const dataUrl = this.getDataUrl(ii);
              this.materialTexturesSelection.push(dataUrl);
            }
          }

          if (materials[i].normalTexture) {
            let source = materials[i].normalTexture.texture.source;
            let sym = Object.getOwnPropertySymbols(source).find(function (s) {
              return String(s) === "Symbol(correlatedObjects)";
            });

            let ii = source[sym].entries().next().value[0].image;

            const dataUrl = this.getDataUrl(ii);
            this.materialTexturesSelection.push(dataUrl);
          }
          if (materials[i].occlusionTexture) {
            let source = materials[i].occlusionTexture.texture.source;
            let sym = Object.getOwnPropertySymbols(source).find(function (s) {
              return String(s) === "Symbol(correlatedObjects)";
            });
            let ii = source[sym].entries().next().value[0].image;
            const dataUrl = this.getDataUrl(ii);
            this.materialTexturesSelection.push(dataUrl);
          }
          if (materials[i].emissiveTexture) {
            let source = materials[i].emissiveTexture.texture.source;
            let sym = Object.getOwnPropertySymbols(source).find(function (s) {
              return String(s) === "Symbol(correlatedObjects)";
            });
            let ii = source[sym].entries().next().value[0].image;
            const dataUrl = this.getDataUrl(ii);
            this.materialTexturesSelection.push(dataUrl);
          }
        }
      });
      //animation list
      thumbnailElement.iosSrc = usdz;
      //lazy load
      thumbnailElement.poster = png;
    },
    getDataUrl(img) {
      // Create canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      // Set width and height
      canvas.width = img.width;
      canvas.height = img.height;
      // Draw the image
      ctx.drawImage(img, 0, 0);
      return canvas.toDataURL("image/jpeg");
    },
    Listen() {
      console.log("hi listener");
      const modelViewer = document.querySelector("model-viewer");
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      modelViewer.removeEventListener("camera-change", this.Listen);

      modelViewer.addEventListener("camera-change", this.Listen1);
    },
    Listen1() {
      console.log("hi listener1");
      const modelViewer = document.querySelector("model-viewer");
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      modelViewer.removeEventListener("camera-change", this.Listen1);

      modelViewer.addEventListener("camera-change", this.Listen2);
    },
    Listen2() {
      console.log("hi listener2");
      const modelViewer = document.querySelector("model-viewer");
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      this.screenShotModel1().then((result) => console.log(result));

      modelViewer.removeEventListener("camera-change", this.Listen2);

      //modelViewer.addEventListener("camera-change", this.Listen2);
    },

    removeHDR() {
      var hdr = document.getElementsByTagName("model-viewer")[0];
      if (typeof hdr != "undefined" && hdr != null) {
        hdr.removeAttribute("skybox-image");
      }
    },
    addAnnotationOnHotSpot() {
      this.tempHotSpot = false;
      //this.screenShotModel1().then((result) => console.log(result));

      var item = {
        color: "",
        title: "",
        description: "",
      };

      item.color = this.selectColor;
      item.title = this.annotationTitle;
      item.description = this.annotationText;
      //this.items.unshift(item);

      this.annotationTitle = "";
      this.annotationText = "";
      this.selectColor = this.randColorHex();

      this.isAnnotation = !this.isAnnotation;
      this.addHotSpot(this.positionAndNormal1, item.color, item);

      //return this.items;
    },
    removeTempHotSpot() {
      if (this.tempHotSpot === true) {
        this.isAnnotation = false;
        this.tempHotSpot = false;
        this.hotspotCounter = this.hotspotCounter - 1;
        let viewer = new ModelViewerElement();
        viewer = document.getElementById("loading-demo");
        viewer.removeChild(viewer.lastChild);
      }
    },
    checkTempHotSpot(positionAndNormal) {
      if (this.tempHotSpot === false) {
        this.tempHotSpot = true;
        this.addTempHotSpot(positionAndNormal);
      } else {
        this.hotspotCounter = this.hotspotCounter - 1;
        let viewer = new ModelViewerElement();
        viewer = document.getElementById("loading-demo");
        viewer.removeChild(viewer.lastChild);
        this.addTempHotSpot(positionAndNormal);
      }
    },
    addTempHotSpot(positionAndNormal) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");

      if (positionAndNormal == null) {
        return;
      }
      const { position, normal } = positionAndNormal;

      const hotspot = document.createElement("b");
      hotspot.slot = `hotspot-${this.hotspotCounter++}`;

      hotspot.classList.add("hotspot");
      hotspot.dataset.position = position.toString();
      if (normal != null) {
        hotspot.dataset.normal = normal.toString();
      }
      viewer.appendChild(hotspot);
      //this.hotspotselect(hotspot);

      const label = document.createElement("div");
      label.classList.add("annotation");

      const span1 = document.createElement("span");
      span1.style.color = "#ffffff";

      span1.textContent = this.decodeHtml("&#9675;");
      span1.style.fontSize = "xx-large";
      label.appendChild(span1);

      hotspot.appendChild(label);

      //add automatic cursor on title field
      document.getElementById("changeDotTitle").focus();
    },
    addAnnotation() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        this.cameraOrbit = viewer.getCameraOrbit().toString();
        this.fieldOfView = viewer.getFieldOfView().toString();

        this.isAnnotation = true;

        const rect = viewer.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        this.positionAndNormal1 = viewer.positionAndNormalFromPoint(x, y);
        //console.log(this.positionAndNormal1);

        this.checkTempHotSpot(this.positionAndNormal1);
      }
    },
    addHotSpot(positionAndNormal, hotspotColor, hotspotDes) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");

      //const rect = viewer.getBoundingClientRect();
      //const x = event.clientX - rect.left;
      //const y = event.clientY - rect.top;
      //const positionAndNormal = viewer.positionAndNormalFromPoint(x, y);

      //console.log(x, y);
      //console.log(positionAndNormal);
      if (positionAndNormal == null) {
        //console.log("no hit result: mouse = ", x, ", ", y);
        return;
      }
      const { position, normal } = positionAndNormal;

      const hotspot = document.createElement("b");
      hotspot.slot = `hotspot-${this.hotspotCounter++}`;

      hotspot.classList.add("hotspot");
      hotspot.dataset.position = position.toString();
      if (normal != null) {
        hotspot.dataset.normal = normal.toString();
      }
      viewer.appendChild(hotspot);
      this.hotspotselect(hotspot);

      const label = document.createElement("div");
      label.classList.add("annotation");

      //label.textContent = `${this.hotspotCounter}`;
      //label.style.fontSize = "xx-large";
      //label.textContent = "\uD83D\uDD34";

      const span1 = document.createElement("span");
      span1.style.color = hotspotColor;

      span1.textContent = this.decodeHtml("&#9679;");
      span1.style.fontSize = "xx-large";
      label.appendChild(span1);

      /*
      label.textContent =
        "data-position:\r\n" + position + "\r\ndata-normal:\r\n" + normal;
      
      */
      hotspot.appendChild(label);

      //data send to server for hotspot
      /*
      let formData = new FormData();
      formData.append("file_glb", this.file);
      formData.append("file_name", file.name);
      formData.append("file_type", this.extention);
      */
      axios
        .get(
          this.$abServerPath + "/api/glbfiles/glbgetfile/" + this.fileID + "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          this.hotspotItems = response.data.hotspots;

          this.fileName = response.data.filename;
          this.extention = response.data.filetype;
          this.fileusdz = "" + response.data.fileusdz;
          this.file = response.data.fileglb;
          this.filePNG = response.data.filepng;

          var item = {
            color: "",
            dataposition: "",
            datanormal: "",
            title: "",
            description: "",
            cameraPosition: "",
          };

          item.color = hotspotColor;
          item.dataposition = position.toString();
          item.datanormal = normal.toString();
          item.title = hotspotDes.title;
          item.description = hotspotDes.description;
          //already toString from double click event
          item.cameraPosition = this.cameraOrbit;

          // console.log(JSON.stringify(this.hotspotItems));
          // console.log("rrrrrr");
          this.hotspotItems.unshift(item);
          // console.log(JSON.stringify(this.hotspotItems));
          // console.log("iopipoi");

          var i;
          var len;

          for (i = 0, len = this.hotspotItems.length; i < len; i++) {
            delete this.hotspotItems[i]["filename"];
          }
          // console.log(JSON.stringify(this.hotspotItems));
          // console.log("jlkjllk");

          var data = {
            filename: "",
            filetype: "",
            hotspots: "",
          };

          data.filename = this.fileName;
          data.filetype = this.extention;
          data.hotspots = this.hotspotItems;

          axios
            .put(
              this.$abServerPath +
                "/api/glbfiles/glbputfile/" +
                this.fileID +
                "/",
              data,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Token " + this.getAuthCookie("augmentableUserToken") + "",
                },
              }
            )
            .then((response) => {
              console.log(response);
              this.updatedTasksData();

              console.log("SUCCESS!!");
            })
            .catch(function () {
              console.log("FAILURE!!");
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hotspotselect(hotspot) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      for (let i = 0; i < viewer.children.length; i++) {
        viewer.children[i].classList.remove("selected");
      }
      hotspot.classList.add("selected");
      this.selectedHotspot = hotspot;
    },
    simpleNotification() {
      this.simpleNotificationPosition = !this.simpleNotificationPosition;
      if (
        this.annotationPositionDiv === true &&
        this.simpleNotificationPosition === true &&
        this.annotationNotificationPosition === true
      ) {
        this.simplePositionDiv = false;
      } else if (
        this.simpleNotificationPosition === true &&
        this.annotationNotificationPosition === false
      ) {
        this.simplePositionDiv = true;
        this.annotationPositionDiv = false;
      } else if (
        this.simpleNotificationPosition === false &&
        this.annotationNotificationPosition === true
      ) {
        this.simplePositionDiv = false;
        this.annotationPositionDiv = true;
      }
    },
    annotationNotification() {
      //to change the camera position and turnableRotation
      // let viewer = new ModelViewerElement();
      // viewer = document.getElementById("loading-demo");
      // viewer.cameraOrbit = "auto auto auto";
      // viewer.resetTurntableRotation();
      //to change the camera position and turnableRotation

      this.annotationNotificationPosition =
        !this.annotationNotificationPosition;

      //added to hide and show annotations

      //now added hot fix
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");
      modelViewer.cameraOrbit = "0deg 75deg 105%";
      modelViewer.cameraTarget = "auto auto auto";
      if (this.annotationNotificationPosition) {
        this.showAnnotation();
      } else {
        this.hideAnnotation();
      }

      //added to hide and show annotations
      if (
        this.simplePositionDiv === true &&
        this.simpleNotificationPosition === true &&
        this.annotationNotificationPosition === true
      ) {
        this.annotationPositionDiv = false;
      } else if (
        this.simpleNotificationPosition === true &&
        this.annotationNotificationPosition === false
      ) {
        this.simplePositionDiv = true;
        this.annotationPositionDiv = false;
      } else if (
        this.simpleNotificationPosition === false &&
        this.annotationNotificationPosition === true
      ) {
        this.simplePositionDiv = false;
        this.annotationPositionDiv = true;
      }
    },
    fg(x) {
      this.$router.push({ name: "changeSpotV", params: { slug: x } });
      //changed because I made two child names by using one single route
      //this.$router.push({ path: "/changespot/" + x + "" });
    },
    //below one is not being used currently
    addHashToLocation(params) {
      console.log(this.$route.path);
      console.log(this.$route);
      history.pushState({}, null, params);
    },
    arrangeChangeHotSpotDiv() {
      var newChild = document.createElement("span");
      var oldChild = document.getElementById("changeCardPopUp");
      var parentDiv = oldChild.parentNode;
      oldChild = parentDiv.replaceChild(newChild, oldChild);
      parentDiv.removeChild(newChild);
      oldChild.style.display = "none";
      var ParentDOM = document.getElementById("ParentDOM");
      ParentDOM.appendChild(oldChild);
    },
    location(e, f) {
      //to reArrange absolute divs around hotspots
      this.arrangeChangeHotSpotDiv();

      this.fileID = f;
      this.locationGLB = e;

      axios
        .get(
          this.$abServerPath + "/api/glbfiles/glbgetfile/" + this.fileID + "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          this.hotspotItems = response.data.hotspots;
          // console.log("gjgjh");
          // console.log(this.hotspotItems);
          this.fileName = response.data.filename;
          this.extention = response.data.filetype;
          this.fileusdz = this.$abServerPath + "" + response.data.fileusdz;
          this.file = this.$abServerPath + "" + response.data.fileglb;
          this.filePNG = this.$abServerPath + "" + response.data.filepng;

          if (response.data.fileConfig) {
            this.fileConfig = JSON.parse(response.data.fileConfig);
          } else {
            this.fileConfig = "";
          }

          document
            .querySelectorAll(".drop-zone__input")
            .forEach((inputElement) => {
              const dropZoneElement = inputElement.closest(".drop-zone");
              this.updateThumbnail1(
                dropZoneElement,
                e,
                this.fileusdz,
                this.filePNG
              );
            });

          var i;
          var len;

          //before adding data of hotspot, remove prior hotspot data from list
          this.items = [];
          //before adding data of hotspot, remove hotspot numbering
          this.hotspotCounter = 0;

          //reverse loop to rearrange the hotspot points
          // len = this.hotspotItems.length - 1;

          len = this.hotspotItems.length;

          // console.log("checking links");
          // console.log(len);
          // console.log("checking links");

          // for (i = len; i >= 0; i--) {
          //   //delete this.hotspotItems[i]["id"];
          //   //delete this.hotspotItems[i]["filename"];

          //   this.addHotSpotData(this.hotspotItems[i]);
          // }

          for (i = 0; i < len; i++) {
            this.addHotSpotData(this.hotspotItems[i]);
          }

          //to hide hotspots for the first time
          this.annotationNotificationPosition = false;
          this.hideAnnotation();
          //to hide hotspots for ths first time

          /*
          for (i = 0, len = this.hotspotItems.length; i < len; i++) {
            delete this.hotspotItems[i]["id"];
            delete this.hotspotItems[i]["filename"];

            this.addHotSpotData(this.hotspotItems[i]);
          }
          */

          // console.log(JSON.stringify(this.hotspotItems));
          // console.log("jlkjllk");
        })
        .catch((error) => {
          console.log(error);
        });

      this.isCMS = false;
    },
    addHotSpotData(hotspotdata) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");

      //const { position, normal } = positionAndNormal;

      const hotspot = document.createElement("b");
      hotspot.slot = `hotspot-${this.hotspotCounter++}`;

      hotspot.classList.add("hotspot");

      hotspot.dataset.position = hotspotdata.dataposition;
      hotspot.dataset.normal = hotspotdata.datanormal;

      viewer.appendChild(hotspot);
      this.hotspotselect(hotspot);

      const label = document.createElement("div");
      label.classList.add("annotation");

      const span1 = document.createElement("span");
      span1.style.color = hotspotdata.color;

      span1.textContent = this.decodeHtml("&#9679;");
      span1.style.fontSize = "xx-large";
      label.appendChild(span1);

      hotspot.appendChild(label);

      //add ID from hotspot
      hotspot.id = "hotspot-" + hotspotdata.id;

      //card details
      var item = {
        color: "",
        title: "",
        description: "",
        changeSpotLink: "",
        id: "",
      };

      item.color = hotspotdata.color;
      item.title = hotspotdata.title;
      item.description = hotspotdata.description;
      item.changeSpotLink = hotspotdata.slug;
      item.id = hotspotdata.id;
      item.assignedTo = hotspotdata.assignedTo;
      item.created_at = this.dateFormat(hotspotdata.created_at);
      item.owner = hotspotdata.owner;
      this.items.unshift(item);

      //here
      hotspot.addEventListener("click", () => {
        //confirmed to center
        //viewer.setAttribute("camera-target", hotspotdata.dataposition);
        if (hotspotdata.cameraPosition) {
          viewer.cameraOrbit = hotspotdata.cameraPosition;
          //viewer.fieldOfView = this.fieldOfView;
        }

        this.hotspotselect(hotspot);
        var t = document.getElementById("changeCardPopUp");

        // hotspot.style.border = "2px solid blue";
        // //hotspot.style.padding = "-10px";
        // hotspot.style.borderRadius = "50%";

        this.changeCardTitle = item.title;
        this.changeCardDescription = item.description;
        this.changeCardID = item.id;
        this.changeCardSlug = item.changeSpotLink;

        t.style.display = "block";
        t.style.fontFamily = "Nunito Sans";

        //console.log(hotspot.slot.split("-").pop());

        hotspot.appendChild(t);

        // if (this.changeDotClick === false) {
        //   this.changeDotClick = true;

        //   this.changeCardTitle = item.title;
        //   this.changeCardDescription = item.description;
        //   this.changeCardID = item.id;
        //   this.changeCardSlug = item.changeSpotLink;

        //   t.style.display = "block";

        //   //console.log(hotspot.slot.split("-").pop());

        //   hotspot.appendChild(t);
        // } else {
        //   this.changeDotClick = false;
        //   t.style.display = "none";

        //   //console.log(hotspot.slot.split("-").pop());
        //   hotspot.appendChild(t);
        // }

        // this.$alert(item.description, item.title).then(() =>
        //   console.log("Closed")
        // );
      });

      return this.items;
    },
    goingToChangeDot(x) {
      // event.preventDefault();
      document.getElementById("hotspot-" + x).click();
    },
    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    // toDegrees(cartesian3Pos) {
    //   let pos = Cesium.Cartographic.fromCartesian(cartesian3Pos);
    //   return [(pos.longitude / Math.PI) * 180, (pos.latitude / Math.PI) * 180];
    // },
    updatedTasksData() {
      this.items = [];

      axios
        .get(
          this.$abServerPath + "/api/glbfiles/glbgetfile/" + this.fileID + "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          let viewer = new ModelViewerElement();
          viewer = document.getElementById("loading-demo");
          //before adding data of hotspot, remove prior hotspot data from list
          this.items = [];
          //before adding data of hotspot, remove hotspot numbering
          this.hotspotCounter = 0;

          //to reArrange absolute divs around hotspots
          this.arrangeChangeHotSpotDiv();

          //remove everyChild of viewer to gain new ones with response data
          while (viewer.lastElementChild) {
            viewer.removeChild(viewer.lastElementChild);
          }

          //mount new hotspot data
          let x;
          let len1;
          for (x = 0, len1 = response.data.hotspots.length; x < len1; x++) {
            this.addHotSpotData(response.data.hotspots[x]);
          }

          // //show annotations
          // this.showAnnotation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteTheTaskAnnotation(x) {
      confirm("Are you sure you want to delete this?") &&
        this.deleteAnnotation(x);
    },
    deleteAnnotation(id) {
      axios
        .delete(
          this.$abServerPath + "/api/glbfiles/glbdeletetask/" + id + "/",
          {
            headers: {
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.updatedTasksData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickOutside() {
      this.isAnnotation = false;
    },

    openCMS() {
      this.isCMS = true;
    },
    openCMSBig() {
      //this.isCMS = true;
      //this.$store.commit("setViewerPath", viewer.src);
      this.$router.push({ path: "/dashboard" });
    },
    goToAssetsPage() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer && store.state.fileDetail) {
        this.$router.push({
          name: "File Detail",
          params: { slug: store.state.fileDetail.slug },
        });
      } else {
        this.$router.push({ path: "/assets" });
      }
    },
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;

      return txt.value;
    },
    async screenShotModel() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      let posterUrl = "";
      const a = document.createElement("a");
      const orbit = viewer.getCameraOrbit();

      viewer.fieldOfView = "auto";
      const fov = viewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      //orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;
      console.log(orbit);
      viewer.fieldOfView = "auto";
      //viewer.jumpCameraToGoal();
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));
      URL.revokeObjectURL(posterUrl);
      const blob = await viewer.toBlob({
        mimeType: "image/png",
        idealAspect: true,
      });
      console.log(blob);

      posterUrl = URL.createObjectURL(blob);
      a.href = posterUrl;
      a.download = "screenshot.png";
      a.click();
    },
    async screenShotModel1() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      let posterUrl = "";
      //const a = document.createElement("a");
      const orbit = viewer.getCameraOrbit();

      viewer.fieldOfView = "auto";
      const fov = viewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      //orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;
      console.log(orbit);
      viewer.fieldOfView = "auto";
      //viewer.jumpCameraToGoal();
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));
      URL.revokeObjectURL(posterUrl);
      const blob = await viewer.toBlob({
        mimeType: "image/png",
        idealAspect: true,
      });
      console.log(blob);

      //let image = this.fileName + ".png";
      let formData = new FormData();
      formData.append("fileglb", this.file);
      formData.append("filepng", blob, this.fileName);
      formData.append("filename", this.fileName);
      formData.append("filetype", this.extention);

      axios
        .post(this.$abServerPath + "/api/glbfiles/glbpostfile/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () {
          //viewer.src = "static/images/" + this.fileName;
          console.log("SUCCESS!!");
        })
        .catch(function () {
          console.log("FAILURE111!!");
        });
    },

    async thumbnailGenerate() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      let posterUrl = "";
      //const a = document.createElement("a");
      const orbit = viewer.getCameraOrbit();

      viewer.fieldOfView = "auto";
      const fov = viewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      //orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;
      console.log(orbit);
      viewer.fieldOfView = "auto";
      //viewer.jumpCameraToGoal();
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));
      URL.revokeObjectURL(posterUrl);
      const blob = await viewer.toBlob({
        mimeType: "image/png",
        idealAspect: true,
      });
      return blob;
    },

    async addVersionToServer() {
      let options = {
        binary: true,
        trs: true,
        onlyVisible: true,
        //maxTextureSize: 256,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");

      let file = "";
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        file = new File([glTF], options.binary ? "export.glb" : "export.gltf");
      } else {
        alert("Sorry, no version can be generated");
        return;
      }

      let imageBlob = await this.thumbnailGenerate();

      let extention = "glb";

      //fileSize
      let fileSize = "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";

      let formData = new FormData();

      formData.append(
        "fileglb",
        file,
        this.fileName + "." + extention.toLowerCase()
      );

      formData.append("filepng", imageBlob, this.fileName + ".png");

      formData.append("filetype", extention);

      formData.append("description", "");

      formData.append("state", "unProcessed");

      formData.append("tags", "[]");

      formData.append("filesize", fileSize);
      formData.append("linkHDR", "");
      formData.append("fileusdz", "");

      formData.append("fileOriginal", "");
      formData.append("fileBin", "");
      formData.append("fileMtl", "");

      formData.append("fileConfig", null);

      // + this.selectedVersionFile + "/"
      axios
        .post(
          this.$abServerPath +
            "/api/glbfiles/glbpostfileversion/" +
            this.fileName +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then(() => {
          //console.log(response.data);
          this.goToAssetsPage();
          //viewer.src = "static/images/" + this.fileName;

          // this.$router.push({
          //   name: "File Detail",
          //   params: { slug: store.state.fileDetail.slug },
          // });
          // console.log(response.data);
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log(error.data);
          this.goToAssetsPage();
          //console.log("ffff");
          // this.$router.push({
          //   name: "File Detail",
          //   params: { slug: store.state.fileDetail.slug },
          // });
        });

      this.overlayP = true;
    },

    hdrSelectActive(x) {
      //alert(this.hotspotItems);

      var data = {
        linkHDR: "",
        //filename: "",
      };

      data.linkHDR = x;
      // data.filename = "wdwd";

      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputHDRfile/" +
            this.fileID +
            "/",
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });

      this.changeHDRfile(x);
    },
    hdrSelect(x) {
      //alert(x);
      this.hdrItem = x;
      this.changeHDRfile(x);
    },
    addHDR() {
      alert("Drop HDR file in the viewer");
    },
    deleteHDR(x) {
      confirm("Are you sure you want to delete this item?") &&
        this.deleteHDRItem(x);
    },
    deleteHDRItem(x) {
      axios
        .delete("/api/hdrfiles/hdrdeletefile/" + x + "/", {
          headers: {
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          console.log(response);

          axios
            .get("/api/hdrfiles/hdrgetallfile/", {
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Token " + this.getAuthCookie("augmentableUserToken") + "",
              },
            })
            .then((response) => {
              this.hdrFileItems = [];
              var i;
              var len;

              var obj = {
                file_hdr: "",
                file_name: "",
                id: "",
              };

              for (i = 0, len = response.data.length; i < len; i++) {
                obj = response.data[i];
                //console.log(response.data[i]);
                obj.file_hdr = "" + response.data[i].file_hdr;
                obj.file_name = "" + response.data[i].file_name;
                obj.id = response.data[i].id;

                //this.hdrSelectItems.push(response.data[i].file_name);
                this.hdrFileItems.push(obj);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    hdrSettingsFunc() {
      this.$refs["hdrSettings"].toggle();
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    playNextAnimation() {
      let animationPCN = this.findAnimationIndex();
      console.log(animationPCN[0] + "  " + animationPCN[1]);
      this.animationSelect = animationPCN[2];
      this.animationSelected(animationPCN[2]);
    },
    playPreviousAnimation() {
      let animationPCN = this.findAnimationIndex();
      console.log(animationPCN[1] + "  " + animationPCN[2]);
      this.animationSelect = animationPCN[0];
      this.animationSelected(animationPCN[0]);
    },
    findAnimationIndex() {
      var index = this.animationList.findIndex(
        (x) => x === this.animationSelect
      );
      var lastIndex = this.animationList.length - 1;

      var previousAnimationName = "";
      var nextAnimationName = "";

      let checkNext = lastIndex - index;
      let checkPrevious = index - 0;
      if (checkNext > 0) {
        nextAnimationName = this.animationList[index + 1];
      } else {
        nextAnimationName = this.animationList[0];
      }
      if (checkPrevious > 0) {
        previousAnimationName = this.animationList[index - 1];
      } else {
        previousAnimationName = this.animationList[lastIndex];
      }

      return [previousAnimationName, this.animationSelect, nextAnimationName];
    },
    async animationSelected(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        viewer["animationName"] = x;
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },
    async insertOtherAnimationSelected(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        viewer["animationName"] = x;
        this.animationCombined = false;
        this.glbAnimation = false;
        await this.sleep(1);
        this.animationCombined = true;
        // this.animationLoop = true;
        this.glbAnimation = true;
      }
    },

    sliderEvent() {
      console.log("clicked and checked");
    },
    sliderEvent1(x, y) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        console.log(x, y);
        viewer[x] = parseFloat(y);
      }
    },
    glbRotationFunc() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        if (this.glbRotation === true) {
          console.log(this.glbRotation);
          viewer["autoRotate"] = true;
        } else {
          console.log(this.glbRotation);
          viewer["autoRotate"] = false;
        }
      }
    },
    showColorMC1() {
      console.log(
        JSON.stringify(
          Object.keys(this.selectColorMC).reduce((selectColorMC, key) => {
            selectColorMC[key] = Number(this.selectColorMC[key].toFixed(2));
            return selectColorMC;
          }, {}),
          null,
          2
        )
      );
      console.log(this.selectColorMC);
    },
    randColorHex() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async modelDownload(binary) {
      let options = {
        binary: binary,
        trs: true,
        onlyVisible: true,
        //maxTextureSize: 256,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };
      console.log("download");
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        var file = new File([glTF], binary ? "export.glb" : "export.gltf");
        var link = document.createElement("a");
        link.download = file.name;
        link.href = URL.createObjectURL(file);
        link.click();
      }
    },

    downloadFiles() {
      //var len;
      //var i;

      this.downloadMenu = true;

      if (this.downloadOriginalFile === true) {
        console.log("original glb file");

        let viewer = new ModelViewerElement();
        viewer = document.getElementById("loading-demo");

        if (viewer) {
          var link = document.createElement("a");
          //link.download = this.fileName;
          link.download = this.fileName + ".glb";
          link.href = viewer.src;
          link.click();
        }
      }
      if (this.downloadGLB === true) {
        console.log("glb file");
        this.modelDownload(true);
      }
      if (this.downloadGLTF === true) {
        console.log("GLTF File");
        this.modelDownload(false);
      }

      if (this.downloadUSDZ === true) {
        console.log("USDZ File");
        if (this.fileusdz === "") {
          console.log("empty");
        } else {
          var downloadName1 = this.fileName + ".usdz";
          var link1 = document.createElement("a");
          link1.download = downloadName1;
          link1.href = this.fileusdz;
          link1.click();
        }
      }

      // //len = this.downloadFileItems.length - 1;
      // len = this.filebtns.length - 1;
      // for (i = len; i >= 0; i--) {
      //   if (
      //     // this.downloadFileItems[i]["title"] === "Original GLB File" &&
      //     // this.downloadFileItems[i]["value"] === true
      //     // this.filebtns[i].name === "ORIGINAL FILE" &&
      //     // this.filebtns[i].checked === true

      //     this.downloadFileItems[i].value === "Original" &&
      //     this.downloadFileItems[i].checked === true
      //   ) {
      //     //console.log("original glb file");

      //     let viewer = new ModelViewerElement();
      //     viewer = document.getElementById("loading-demo");

      //     if (viewer) {
      //       var link = document.createElement("a");
      //       link.download = this.fileName;
      //       link.href = viewer.src;
      //       link.click();
      //     }
      //   }
      //   if (
      //     // this.downloadFileItems[i]["title"] === "GLB File" &&
      //     // this.downloadFileItems[i]["value"] === true
      //     // this.filebtns[i].name === "GLB" &&
      //     // this.filebtns[i].checked === true

      //     this.downloadFileItems[i].value === "glb" &&
      //     this.downloadFileItems[i].checked === true
      //   ) {
      //     console.log("glb file");

      //     this.modelDownload(true);
      //   }
      //   if (
      //     // this.downloadFileItems[i]["title"] === "GLTF File" &&
      //     // this.downloadFileItems[i]["value"] === true
      //     // this.filebtns[i].name === "GLTF" &&
      //     // this.filebtns[i].checked === true
      //     this.downloadFileItems[i].value === "gltf" &&
      //     this.downloadFileItems[i].checked === true
      //   ) {
      //     console.log("GLTF File");
      //     this.modelDownload(false);
      //   }
      //   if (
      //     // this.downloadFileItems[i]["title"] === "USDZ File" &&
      //     // this.downloadFileItems[i]["value"] === true
      //     // this.filebtns[i].name === "USDZ" &&
      //     // this.filebtns[i].checked === true
      //     this.downloadFileItems[i].value === "usdz" &&
      //     this.downloadFileItems[i].checked === true
      //   ) {
      //     alert("ggg");
      //     if (this.fileusdz === "") {
      //       console.log("empty");
      //     } else {
      //       console.log(this.fileName + "" + this.fileusdz);
      //       var downloadName1 = this.fileName + ".usdz";
      //       var link1 = document.createElement("a");
      //       link1.download = downloadName1;
      //       link1.href = this.fileusdz;
      //       link1.click();
      //     }
      //     console.log("USDZ File");
      //   }
      // }
    },

    toggleFullScreen() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    openARwindow() {
      //console.log("gjg");
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        //console.log(viewer.src);
        //console.log(viewer.iosSrc);
        this.$store.commit("setViewerPath", viewer.src);
        this.$store.commit("setViewerIosPath", viewer.iosSrc);
        this.$router.push({ path: "/viewerAR" });
      }
    },
    changeHDRfile(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        //viewer.setAttribute("skybox-image", x);
        viewer.setAttribute("environment-image", x);

        //added skybox due to refresh
        this.asSkybox = false;
      }
    },

    changeTargetSkybox(event) {
      console.log(event.pageX), console.log(event.pageY);

      //panning
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      event.preventDefault();

      let lastX;
      let panning = false;
      let skyboxAngle = 0;
      let radiansPerPixel;

      const startPan = () => {
        const orbit = modelViewer.getCameraOrbit();
        const { radius } = orbit;
        radiansPerPixel =
          (-1 * radius) / modelViewer.getBoundingClientRect().height;
        modelViewer.interactionPrompt = "none";
      };

      const updatePan = (thisX) => {
        const delta = (thisX - lastX) * radiansPerPixel;
        lastX = thisX;
        skyboxAngle += delta;
        const orbit = modelViewer.getCameraOrbit();
        orbit.theta += delta;
        modelViewer.cameraOrbit = orbit.toString();
        modelViewer.resetTurntableRotation(skyboxAngle);
        modelViewer.jumpCameraToGoal();
      };

      modelViewer.addEventListener(
        "mousedown",
        (event) => {
          panning =
            event.button === 2 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey;
          if (!panning) return;

          lastX = event.clientX;
          startPan();
          event.stopPropagation();
        },
        true
      );

      modelViewer.addEventListener(
        "touchstart",
        (event) => {
          panning = event.touches.length === 2;
          if (!panning) return;

          const { touches } = event;
          lastX = 0.5 * (touches[0].clientX + touches[1].clientX);
          startPan();
        },
        true
      );

      modelViewer.addEventListener(
        "mousemove",
        (event) => {
          if (!panning) return;

          updatePan(event.clientX);
          event.stopPropagation();
        },
        true
      );

      modelViewer.addEventListener(
        "touchmove",
        (event) => {
          if (!panning || event.touches.length !== 2) return;

          const { touches } = event;
          const thisX = 0.5 * (touches[0].clientX + touches[1].clientX);
          updatePan(thisX);
        },
        true
      );

      self.addEventListener(
        "mouseup",
        (event) => {
          panning = false;
          console.log(event);
        },
        true
      );

      self.addEventListener(
        "touchend",
        (event) => {
          panning = false;
          console.log(event);
        },
        true
      );
    },

    changeTarget(e) {
      // if (e.shiftKey){
      //   this.changeTargetSkybox(e);
      //   return;
      //   }
      // // else{
      // //   this.someAction()
      // //   }

      console.log(e.pageX), console.log(e.pageY);
      //hdri
      //let lasthdriX;
      let panningHdri = false;
      let skyboxAngle = 0;
      let radiansPerPixel;
      //hdri

      //panning
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      const tapDistance = 2;
      let panning = false;
      let panX, panY;
      let startX, startY;
      let lastX, lastY;
      let metersPerPixel;

      const startPan = () => {
        const orbit = modelViewer.getCameraOrbit();
        const { theta, phi, radius } = orbit;
        metersPerPixel =
          (0.75 * radius) / modelViewer.getBoundingClientRect().height;
        panX = [-Math.cos(theta), 0, Math.sin(theta)];
        panY = [
          -Math.cos(phi) * Math.sin(theta),
          Math.sin(phi),
          -Math.cos(phi) * Math.cos(theta),
        ];
        modelViewer.interactionPrompt = "none";
      };

      const movePan = (thisX, thisY) => {
        const dx = (thisX - lastX) * metersPerPixel;
        const dy = (thisY - lastY) * metersPerPixel;
        lastX = thisX;
        lastY = thisY;

        const target = modelViewer.getCameraTarget();
        target.x += dx * panX[0] + dy * panY[0];
        target.y += dx * panX[1] + dy * panY[1];
        target.z += dx * panX[2] + dy * panY[2];
        modelViewer.cameraTarget = `${target.x}m ${target.y}m ${target.z}m`;
      };

      const recenter = (pointer) => {
        panning = false;
        if (
          Math.abs(pointer.clientX - startX) > tapDistance ||
          Math.abs(pointer.clientY - startY) > tapDistance
        )
          return;
        const rect = modelViewer.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const hit = modelViewer.positionAndNormalFromPoint(x, y);
        modelViewer.cameraTarget =
          hit == null ? "auto auto auto" : hit.position.toString();
      };

      const onPointerUp = (event) => {
        const pointer = event.clientX ? event : event.changedTouches[0];
        if (
          Math.abs(pointer.clientX - startX) < tapDistance &&
          Math.abs(pointer.clientY - startY) < tapDistance
        ) {
          recenter(pointer);
        }
        panning = false;
      };

      //hdri
      const startPanHdr = () => {
        const orbit = modelViewer.getCameraOrbit();
        const { radius } = orbit;
        radiansPerPixel =
          (-1 * radius) / modelViewer.getBoundingClientRect().height;
        modelViewer.interactionPrompt = "none";
      };

      const updatePanHdr = (thisX) => {
        const delta = (thisX - lastX) * radiansPerPixel;
        lastX = thisX;
        skyboxAngle += delta;
        const orbit = modelViewer.getCameraOrbit();
        orbit.theta += delta;
        modelViewer.cameraOrbit = orbit.toString();
        modelViewer.resetTurntableRotation(skyboxAngle);
        modelViewer.jumpCameraToGoal();
      };
      //hdri

      modelViewer.addEventListener(
        "mousedown",
        (event) => {
          startX = event.clientX;
          startY = event.clientY;

          panning = event.which === 3;
          //console.log(event.which);
          //(e.which === 3 || e.button === 2);

          // panningHdri =
          //   event.button === 2 &&
          //   (event.ctrlKey || event.shiftKey || event.metaKey);
          panningHdri = event.which === 2;

          if (panningHdri) {
            //now added hotfix
            modelViewer.cameraOrbit = "0deg 75deg 105%";
            modelViewer.cameraTarget = "auto auto auto";

            panning = false;
          }

          if (!panningHdri && !panning) return;

          lastX = startX;
          lastY = startY;

          if (panning) {
            startPan();
          } else if (panningHdri) {
            startPanHdr();
          }

          event.stopPropagation();
        },
        true
      );

      modelViewer.addEventListener(
        "touchstart",
        (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          panning = event.touches.length === 2;

          panningHdri = event.touches.length === 3;

          if (!panning && !panningHdri) return;

          if (panningHdri) {
            const { touches } = event;
            lastX =
              0.5 *
              (touches[0].clientX + touches[1].clientX + touches[2].clientX);
            startPanHdr();
          } else if (panning) {
            const { touches } = event;
            lastX = 0.5 * (touches[0].clientX + touches[1].clientX);
            lastY = 0.5 * (touches[0].clientY + touches[1].clientY);
            startPan();
          }
        },
        true
      );

      modelViewer.addEventListener(
        "mousemove",
        (event) => {
          if (!panningHdri && !panning) return;

          console.log("yes panning");

          if (panning) {
            movePan(event.clientX, event.clientY);
          } else if (panningHdri) {
            updatePanHdr(event.clientX);
          }

          event.stopPropagation();
        },
        true
      );

      modelViewer.addEventListener(
        "touchmove",
        (event) => {
          if (
            (!panning && !panningHdri) ||
            (event.touches.length !== 2 && event.touches.length !== 3)
          ) {
            return;
          }

          if (panning) {
            const { touches } = event;
            const thisX = 0.5 * (touches[0].clientX + touches[1].clientX);
            const thisY = 0.5 * (touches[0].clientY + touches[1].clientY);
            movePan(thisX, thisY);
          } else if (panningHdri) {
            const { touches } = event;
            const thisX =
              0.5 *
              (touches[0].clientX + touches[1].clientX + touches[2].clientX);
            updatePanHdr(thisX);
          }
        },
        true
      );

      self.addEventListener(
        "mouseup",
        (event) => {
          panningHdri = false;

          onPointerUp(event);
        },
        true
      );

      self.addEventListener(
        "touchend",
        (event) => {
          if (event.touches.length === 0) {
            panningHdri = false;

            recenter(event.changedTouches[0]);
          }
        },
        true
      );

      e.preventDefault();

      //hdri

      // modelViewer.addEventListener(
      //   "mousedown",
      //   (event) => {
      //     panningHdri = event.ctrlKey || event.shiftKey;
      //     if (!panningHdri) return;

      //     lastX = event.clientX;
      //     startPanHdr();
      //     event.stopPropagation();
      //   },
      //   true
      // );

      // modelViewer.addEventListener(
      //   "touchstart",
      //   (event) => {
      //     panningHdri = event.touches.length === 3;
      //     if (!panningHdri) return;

      //     const { touches } = event;
      //     lastX =
      //       0.5 *
      //       (touches[0].clientX + touches[1].clientX + touches[2].clientX);
      //     startPanHdr();
      //   },
      //   true
      // );

      // modelViewer.addEventListener(
      //   "mousemove",
      //   (event) => {
      //     if (!panningHdri) return;

      //     updatePanHdr(event.clientX);
      //     event.stopPropagation();
      //   },
      //   true
      // );

      // modelViewer.addEventListener(
      //   "touchmove",
      //   (event) => {
      //     if (!panningHdri || event.touches.length !== 3) return;

      //     const { touches } = event;
      //     const thisX =
      //       0.5 *
      //       (touches[0].clientX + touches[1].clientX + touches[2].clientX);
      //     updatePanHdr(thisX);
      //   },
      //   true
      // );

      // self.addEventListener(
      //   "mouseup",
      //   (event) => {
      //     panningHdri = false;
      //     console.log(event);
      //   },
      //   true
      // );

      // self.addEventListener(
      //   "touchend",
      //   (event) => {
      //     panningHdri = false;
      //     console.log(event);
      //   },
      //   true
      // );
    },

    //start settings functions
    //   1st btn
    lightf() {
      this.lightbutton = true;
      this.circlebutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },

    //   2nd btn
    circlef() {
      this.circlebutton = true;
      this.lightbutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },

    //3rd btn
    mediaf() {
      this.mediabutton = true;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },

    //4th btn
    colorbtnf() {
      this.colorbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },

    //5th btn
    boxbtnf() {
      this.boxbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //6th btn
    filebtnf() {
      this.filebtncard = true;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //7th btn
    photobtnf() {
      this.photobtncard = true;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.camerabtncard = false;
    },
    //8th btn
    camerabtnf() {
      this.camerabtncard = true;
      this.photobtncard = false;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
    },

    colorf(x) {
      alert(x.color);
    },
    //end settings functions

    saveFileConfig() {
      this.fileConfig = {
        neutralLight: this.neutralLight,
        hdrExposure: this.hdrExposure,
        shadowIntensity: this.shadowIntensity,
        shadowSoftness: this.shadowSoftness,
      };

      let formData = new FormData();
      formData.append("fileConfig", JSON.stringify(this.fileConfig));
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputupdatefile/" +
            this.fileID +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(JSON.parse(response.data.fileConfig));
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    userInfo1() {
      alert(this.username);
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    // userProfile() {
    //   console.log(this.userInfo);
    //   console.log("gjhgjh");
    //   this.$router.push({
    //     name: "User Profile",
    //     params: { userInfo: this.userInfo },
    //   });
    // },
    // userProfile() {
    //   this.$router.push({ path: "/user_profile" });
    // },

    userProfile() {
      if (store.state.userType === "basic") {
        this.$router.push({ path: "/assets" });
      } else {
        this.$router.push({ path: "/user_profile" });
      }
    },
    userLogout() {
      this.$store.commit("setAuthentication", false);
      //expiring cookie and delete
      document.cookie =
        "augmentableUserToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.$router.push({ name: "account" });
    },

    //panning
    panningStart(e) {
      console.log(e.pageX), console.log(e.pageY);

      document
        .getElementById("loading-demo")
        .addEventListener("mousemove", this.panningOn);

      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      //console.log(modelViewer.getBoundingClientRect());
      //console.log(e.pageX + (screen.width - xx.width));

      //working perfectly
      let xx = modelViewer.getBoundingClientRect();
      let left = e.pageX - (screen.width - xx.width);
      let top = e.pageY - (screen.height - xx.height);

      //let left = e.clientX;
      //let top = e.clientY;

      //modelViewer.style.position = "absolute";
      modelViewer.style.transform = "translate(-50%, -50%)";

      modelViewer.style.left = left + "px";
      modelViewer.style.top = top + "px";

      e.preventDefault();
    },
    panningOn(e) {
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      //working perfectly
      let xx = modelViewer.getBoundingClientRect();
      let left = e.pageX - (screen.width - xx.width);
      let top = e.pageY - (screen.height - xx.height);

      modelViewer.style.transform = "translate(-50%, -50%)";

      modelViewer.style.left = left + "px";
      modelViewer.style.top = top + "px";

      e.preventDefault();
    },
    panningStop(e) {
      document
        .getElementById("loading-demo")
        .removeEventListener("mousemove", this.panningOn);
      e.preventDefault();
    },

    panningStartTouch(e) {
      let panning = event.touches.length === 2;
      if (!panning) return;
      //console.log(e.pageX), console.log(e.pageY);

      document
        .getElementById("loading-demo")
        .addEventListener("touchmove", this.panningOnTouch);

      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      //working perfectly
      let xx = modelViewer.getBoundingClientRect();
      let left = e.touches[0].pageX - (screen.width - xx.width);
      let top = e.touches[0].pageY - (screen.height - xx.height);

      modelViewer.style.transform = "translate(-50%, -50%)";

      modelViewer.style.left = left + "px";
      modelViewer.style.top = top + "px";

      e.preventDefault();
    },
    panningOnTouch(e) {
      let panning = event.touches.length !== 2;
      if (!panning) {
        this.panningStopTouch(e);
        return;
      }

      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");

      //working perfectly
      let xx = modelViewer.getBoundingClientRect();
      let left = e.touches[0].pageX - (screen.width - xx.width);
      let top = e.touches[0].pageY - (screen.height - xx.height);

      modelViewer.style.transform = "translate(-50%, -50%)";

      modelViewer.style.left = left + "px";
      modelViewer.style.top = top + "px";

      e.preventDefault();
    },
    panningStopTouch(e) {
      document
        .getElementById("loading-demo")
        .removeEventListener("touchmove", this.panningOn);
      e.preventDefault();
    },
    //panning

    //hdr panning
    // panningHdriStart(e){
    //   panning = event.button === 2 || event.ctrlKey || event.metaKey ||
    //     event.shiftKey;
    // if (!panning)
    //   return;

    // lastX = event.clientX;
    // startPan();
    // event.stopPropagation();
    // },
    // panningHdriOn(e){

    // },
    // panningHdriStop(e){

    // },
    //hdr panning

    async testMaterials() {
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo");
      //GltfMaterial = modelViewer;

      const glTF = await modelViewer.exportScene();

      console.log(glTF);
      console.log("fsdf");
      console.log(glTF.normalTexture);
      console.log("fsdf");
    },

    checkExportFiles(item, index) {
      //console.log(item, index);
      this.filebtns[index].checked = !this.filebtns[index].checked;
      this.downloadFileItems[index].list = this.filebtns[index].checked;

      // if (this.filebtns[index].name === "Draco") {
      //   this.compressed = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "GLB") {
      //  this.glbDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "GLTF") {
      //   this.gltfDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "USD") {
      //   this.usdDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "USDZ") {
      //   this.usdzDown = this.filebtns[index].checked;
      // }
    },
    checkExportValues(item, index) {
      if (this.computedDownloadFileItems[index].value === "original") {
        this.originalGLBfile = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "draco") {
        this.computedDownloadDraco =
          this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "glb") {
        this.downloadGLB = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "gltf") {
        this.downloadGLTF = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "usdz") {
        this.downloadUSDZ = this.computedDownloadFileItems[index].checked;
      }
    },
    checkedOriginal() {
      this.filebtns[0].checked = !this.filebtns[0].checked;
    },

    hideAnnotation() {
      //absolute informative div
      var t = document.getElementById("changeCardPopUp");
      t.style.display = "none";

      //hotspots points
      var el = document.getElementById("loading-demo");
      var c = el.children;
      var i;
      for (i = 0; i < c.length; i++) {
        var elem = c[i];
        elem.style.display = "none";
      }
    },
    showAnnotation() {
      var el = document.getElementById("loading-demo");
      var c = el.children;
      var i;
      for (i = 0; i < c.length; i++) {
        var elem = c[i];
        elem.style.display = "block";
      }
    },
    configureCurrentMaterial(material) {
      if (material.pbrMetallicRoughness) {
        if (
          material.pbrMetallicRoughness.roughnessFactor === 0 &&
          material.pbrMetallicRoughness.metallicFactor === 0
        ) {
          this.metallicFactor = 0.1;
          this.roughnessFactor = 0.9;
        } else {
          this.metallicFactor = material.pbrMetallicRoughness.metallicFactor;
          this.roughnessFactor = material.pbrMetallicRoughness.roughnessFactor;
        }

        let color = material.pbrMetallicRoughness.baseColorFactor;

        // color = this.RGBToHex(color[0], color[1], color[2]);
        // this.baseColorFactor = color;

        this.baseColorFactor = `rgba(${color[0] * 255}, ${color[1] * 255}, ${
          color[2] * 255
        }, ${color[3]})`;
      }

      if (material.emissiveTexture) {
        let color = material.emissiveFactor;
        color = this.RGBToHex(color[0], color[1], color[2]);
        this.emissiveFactor = color;
      }
    },
    clearMaterialData() {
      //to empty/clear
      //this.currentMaterial = [];
      //this.modelMaterials = [];
      this.baseColorFactor = "rgba(255,255,255,1)";
      this.emissiveFactor = "";
      this.roughnessFactor = "";
      this.metallicFactor = "";

      this.materialTextures = {
        metallicRoughnessTexture: "",
        baseColorTexture: "",
        normalTexture: "",
        emissiveTexture: "",
        occlusionTexture: "",
      };
    },
    RGBToHex(r, g, b) {
      r = Math.round(r * 255).toString(16);
      g = Math.round(g * 255).toString(16);
      b = Math.round(b * 255).toString(16);

      if (r.length == 1) r = "0" + r;
      if (g.length == 1) g = "0" + g;
      if (b.length == 1) b = "0" + b;

      return "#" + r + g + b;
    },
    HexToRGB(hex) {
      hex = hex.replace("#", "");
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      let result = [];
      result.push(r / 255);
      result.push(g / 255);
      result.push(b / 255);
      result.push(1);
      return result;
    },

    inputFileClick(textureNum) {
      document.getElementById("inputTexture" + textureNum).click();
    },
    changeTexture(textureNum) {
      var inputElement = document.getElementById("inputTexture" + textureNum);
      console.log(inputElement.files[0]);
      this.getBase64(inputElement.files[0]).then((data) => {
        this.materialTexturesSelection.push(data);
      });
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async applyTextureToModel(item, textureType) {
      if (textureType === "") {
        return;
      }

      var filepng = await fetch(item).then((r) => r.blob());
      var uriSrc = URL.createObjectURL(filepng);
      // a.download = "screenshot.png";
      // a.click();
      for (const property in this.materialTextures) {
        //console.log(`${property}: ${this.materialTextures[property]}`);

        if (property === textureType) {
          if (
            textureType === "baseColorTexture" ||
            textureType === "metallicRoughnessTexture"
          ) {
            if (this.currentMaterial.pbrMetallicRoughness) {
              this.currentMaterial.pbrMetallicRoughness[
                textureType
              ].texture.source.setURI(uriSrc);
              URL.revokeObjectURL(uriSrc);
            }
          } else {
            this.currentMaterial[textureType].texture.source.setURI(uriSrc);
            URL.revokeObjectURL(uriSrc);
          }

          this.materialTextures[textureType] = item;
        }
      }

      this.whichTextureModel = false;
      this.whichTextureModelData = "";
      this.whichTextureModelValue = "";
    },
    async materialHighlight(material) {
      var tempColor = material.emissiveFactor;
      material.setEmissiveFactor([1, 0, 0]);
      await this.sleep(600);
      material.setEmissiveFactor([0.75, 0, 0]);
      await this.sleep(200);
      material.setEmissiveFactor([0.25, 0, 0]);
      await this.sleep(200);
      if (tempColor) {
        material.setEmissiveFactor(tempColor);
      } else {
        material.setEmissiveFactor([0, 0, 0]);
      }
    },
    changeBaseColor(val) {
      const { r, g, b, a } = val.rgba;
      this.baseColorFactor = `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    rgbaStringToArray(color) {
      let colors = [];
      // console.log(typeof(color));
      let color1 = color.replace("rgba(", "");
      let color2 = color1.replace(")", "");
      colors = color2.split(",");
      return colors;
    },

    async checkWhichTexture(file) {
      var textureName;
      var data;
      if (file.name.includes("baseColor") || file.name.includes("BaseColor")) {
        textureName = "baseColorTexture";
      } else if (
        file.name.includes("metallicRoughness") ||
        file.name.includes("MetallicRoughness")
      ) {
        textureName = "metallicRoughnessTexture";
      } else if (file.name.includes("normal") || file.name.includes("Normal")) {
        textureName = "normalTexture";
      } else if (
        file.name.includes("occlusion") ||
        file.name.includes("Occlusion")
      ) {
        textureName = "occlusionTexture";
      } else if (
        file.name.includes("emissive") ||
        file.name.includes("Emissive")
      ) {
        textureName = "emissiveTexture";
      }

      await this.getBase64(file).then((data1) => {
        //this.materialTexturesSelection.push(data1);
        data = data1;
      });
      return { textureName, data };
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");

@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");
// * {
//   font-family: "Nunito Sans" !important;
// }

#a {
  color: var(--selectColor);
}

.notifications_div {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(0%, 15%);
  width: 280px;
  height: 550px;
  font-family: "Raleway";
  background-color: transparent;
}

.notifications_div1 {
  position: absolute;
  right: 250px;
  top: 0;
  transform: translate(0%, 15%);
  width: 250px;
  height: 550px;
  font-family: "Raleway";
  background-color: transparent;
}

.notify_expand {
  width: 280px;
  height: 500px;
  margin-left: -5px;
  overflow-y: scroll;
}

.notify_expand::-webkit-scrollbar {
  display: none;
}

.notify_expand {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.mainARview {
  position: relative;
  /* width:100%; */
  height: 100vh;
  min-height: -webkit-fill-available;
  min-height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
  background-image: radial-gradient(#808080, #262626);
  margin: 0;
  padding: 0;
}
.mainARview1 {
  position: relative;
  /* width:100%; */
  height: 100vh;
  min-height: -webkit-fill-available;
  min-height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
  background-image: radial-gradient(#e6e6e6, #cccccc);
  margin: 0;
  padding: 0;
}

.textARview {
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 12px;
  cursor: pointer;
  font-family: "Raleway";
  position: absolute;
}
.textARview1 {
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: #444444;
  font-size: 12px;
  cursor: pointer;
  font-family: "Raleway";
  position: absolute;
}

.drop-zone {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
  cursor: pointer;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
}

.drop-zone__thumb::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.drop-zoneTexture {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

// .drop-zoneTexture--over {
//   border-style: solid;
// }

.drop-zone__inputTexture {
  display: none;
}

.drop-zone__thumbTexture {
  padding: 0;
  margin: 0;
  width: 50px;
  height: 50px;
}

.drop-zone__thumbTexture::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__promptTexture {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.hotspotBtn {
  display: block;
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 10px;
  border: none;
  background-color: blue;
  box-sizing: border-box;
}

.hotspotBtn[slot="hotspot-hand"] {
  --min-hotspot-opacity: 0;
  background-color: red;
}

.hotspotBtn[slot="hotspot-foot"]:not([data-visible]) {
  background-color: transparent;
  border: 3px solid blue;
}

.hotspot {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border: none;

  background-color: blue;
}

.annotation {
  background-color: red;
  position: absolute;
  width: 30px;
  height: 30px;
  /*
  transform: translate(10px, 10px);
  border-radius: 50%;
  padding: 10px;
  color: red;
  text-align: left; */
}

.annotationpopupb {
  background-color: grey;
  position: absolute;
  width: 280px;
  height: 320px;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  border-radius: 10px;
}
.annotationpopup {
  background-color: white;
  position: absolute;
  width: 250px;
  max-height: 290px;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  border-radius: 10px;
}
.annotationpop {
  top: 50%;
  left: 50%;
  position: absolute;
  //top: calc(50% - 150px); // half of width
  //left: calc(50% - 175px); // half of height

  transform: translate(-50%, -50%);
}

.annotationpopupBack {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(black, 0.5);
  z-index: 90000;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  color: #f1f1f1;
  font-size: 30px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.detailedUI_div {
  position: absolute;
  left: 0;
  top: 0;

  font-family: "Nunito Sans";
  background-color: transparent;
}
.bannerCMS {
  position: absolute;
  top: 2%;
  height: 95%;
  width: 60%;
  background-color: transparent;
  left: 20%;

  font-family: "Nunito Sans";
}

.hotspot.selected {
  background-color: red;
}

.hotspot:not(.selected) > .annotation {
  display: none;
}
.hotspot[slot="hotspot-hand"] {
  --min-hotspot-opacity: 0;
  background-color: red;
}

.file_name_div {
  bottom: 0;
  left: 0;

  width: 100%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: white;
}

.file_name_div1 {
  bottom: 0;
  left: 0;

  width: 100%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: #444444;
}

.file_name_divAR_B {
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: white;
}

.file_name_divAR1_B {
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: #444444;
}

.file_name_divAR {
  bottom: 0;
  left: 0;
  width: 66%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: white;
}

.file_name_divAR1 {
  bottom: 0;
  left: 0;
  width: 66%;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";

  color: #444444;
}

.file_name_div_Z {
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 2%;

  position: absolute;
  font-family: "Nunito Sans";

  color: white;
}

.file_name_div1_Z {
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 2%;

  position: absolute;
  font-family: "Nunito Sans";

  color: #444444;
}

.hdrNavigation {
  top: 0;
  left: 0;

  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";
}

.fullscreenBtn {
  top: 0;
  left: 0;
  width: 50%;
  background-color: transparent;
  position: absolute;
  font-family: "Raleway";
}
.flexcard {
  display: flex;
  flex-direction: column;
}

.horizontolButton {
  overflow-x: scroll !important;
  -webkit-overflow-scrolling: touch;

  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: none;
}

.horizontolButton::-webkit-scrollbar {
  display: none;
}

.expand {
  overflow-x: hidden;
  overflow-y: auto !important;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}

.expand::-webkit-scrollbar {
  width: 5px;
}

.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}

.topHot,
.bottomHot {
  height: 40px;
  width: 100%;
  position: absolute;
  left: 0;
  z-index: 10;
}

.topHot {
  top: 0;
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* FF3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(255, 255, 255, 1)),
    color-stop(100%, rgba(255, 255, 255, 0))
  ); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* Opera 11.10+ */
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* IE10+ */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); /* IE6-9 */
}

.expandHot {
  background-color: transparent;
  min-height: 1vh;
  max-height: 85vh;
  overflow-y: auto;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}
// .expandHot:hover {
//   overflow-y: scroll;
// }

.expandHot::-webkit-scrollbar {
  display: block;
  width: 5px;
}
.expandHot::-webkit-scrollbar-track {
  background: transparent;
}

.expandHot::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 20px;
}
.expandHot::-webkit-scrollbar-track-piece {
  height: unset;
  height: 20px;
}
.expandHot::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 10px;
}

.expandHot::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 10px;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.rHover:hover {
  background-color: transparent;
}
</style>